import { useSnapshot } from "valtio"
import { configStore, contractsStore, entityStore, loginStore, bookingsStore, EntityV2Store, aguserStore } from "../state/CommonState.js"
import { $c, $cr } from '../components/AgComponents.js'
import { useEffect, useRef, useState } from "react"
import Api from "../state/Api.js"
import { MSDS_AND_DG_FILE_MISSING_WARN, Roles, ServerLists } from "../StaticData.js"
import { AgCustomFile } from "../components/AgFile.js"
import BookingsApi from "../state/bookings-api.js"
import { incoTermsList, commodityList, hazardousList } from "../StaticData.js"
import BookingConfirmation from "../schedules/booking-confirmation.js"
import { Agyesno } from "../components/Agyesno.js"
import { AgWarnPopup } from "../components/AgCustomComponents.js"
import BranchApi from "../state/branch-api.js"
import EntityV2Api from "../state/entities-api.js"
import Utils from "../util/Utils.js"
import ShipperApi from "../state/shipper-api.js"
import { CitySelect, StateSelect } from "../entity-v2/components/Country.js"
import LinkEntityPopupv3 from "./linkEntityPopup-v3.js"
import { DummySchedulev3 } from "./dummy-schedule-v3.js"
import LCLScheduleCompv3 from "./LCLScheduleComp-v3.js"
import FCLScheduleCompv3 from "./FCLScheduleComp-v3.js"
import AirScheduleCompv3 from "./AirScheduleComp-v3.js"
import { loader } from "../util/loader.js"
import { BL_TYPE, SHIPPER_PDA, CARRIER_MBL, SHIPMENT_TYPE } from "../util/constants.js"
import * as XLSX from 'xlsx';
import MblConfirmationPopup from "./mblConfirmationPopup.js"
import on from './../components/on.png'
import off from './../components/off.png'
import TenantUtils from "../util/tenant.utils.js"
import { enquiryStore } from "../enquiry/enquiry-data.js"
import InternalV3 from "./Internal-v3.js"
import Newapi from "../state/new-api.js"
import AguserApi from "../state/AguserApi.js"
// import  Utils  from "../util/Utils.js";


export default function CarrierWebFormv3(props) {
    const shipperDefault = { _id: "", firstName: "", lastName: "", emailId: "", mobileNumber: "", companyName: "", address: "", pincode: "", country: "", role: "", city: "", state: "", newShipper: false, linkedEntity: "" }
    let url = window.location.href
    const [space, setSpace] = useState('')
    const [entityData, setentityData] = useState({})
    const [incoEditable, setIncoEditable] = useState(true)
    const [ctypeEditable, setCtypeEditable] = useState(true)
    const [isWarnAccepted, setIsWarnAccepted] = useState(false);
    const [validIncoterms, setValidIncoterms] = useState(true);
    const [validBLTypes, setValidBLTypes] = useState(true);
    const [validCarrierMBL, setValidCarrierMBL] = useState(true);
    const [validHSN, setValidHSN] = useState(true);
    const [validEtdAtPol, setEtdAtPol] = useState(true);
    const [validPDA, setPDA] = useState(true);
    const [branches, setbranches] = useState([]);
    const [validCommodityType, setValidCommodityType] = useState(true);
    const [validbranch, setvalidbranch] = useState(true)
    const [companyName, setCompanyName] = useState('')
    const [validMobile, setValidMobile] = useState(true)
    const [validAddress, setvalidAddress] = useState(true)
    const [addressObj, setaddressObj] = useState({})
    const [validIIPCertificate, setValidIIPCertificate] = useState(true)
    const [validCommercialInvoice, setValidCommercialInvoice] = useState(true)
    const [validPackingList, setValidPackingList] = useState(true)
    const [isButtonClicked, setButtonClicked] = useState(false);
    const [shipperList, setShipperList] = useState([])
    const [shipperSearch, setShipperSearch] = useState('')
    const [buttonClickedAtleastOnce, setbuttonClickedAtleastOnce] = useState(false);
    const [EntityList, setEntityList] = useState([])
    const [showList, setshowList] = useState(false)
    const [cecOc, setCecOc] = useState(null)
    const [cecOd, setCecOd] = useState(null)
    const [newShipper, setNewShipper] = useState(false)
    const [shipperDetails, setShipperDetails] = useState(shipperDefault)
    const [blType, setBlType] = useState('')
    const [shipperPDA, setShipperPDA] = useState('')
    const searchListRef = useRef(null);
    const [showSearchList, setShowSearchList] = useState(false);
    const [consigneeForm, setConsigneeForm] = useState(true)
    const [milestoneAlert, setMilestoneAlert] = useState(true)
    const [agActiveList, setAgActiveList] = useState([])
    const [paymentType, setPaymentType] = useState('Prepaid')
    const [branchesForTypes, setbranchesForTypes] = useState([])
    const [isRMAvailable, setisRMAvailable] = useState(false)
    const [isCSAvailable, setiCSAvailable] = useState(false)
    const dropdownRef = useRef(null);
    const [entityUsers, setEntityUsers] = useState([]);
    const [selectedUserId, setSelectedUserId] = useState('');
    const [shipperEntityUsers, setShipperEntityUsers] = useState([]);
    const [selectedShipperUserId, setSelectedShipperUserId] = useState('');

    let sortedbranches = branchesForTypes.sort()
    const shouldSelectOption = (optionType, selectedValue) => {
        return (
            optionType === selectedValue
        )
    }
    // Event listener to close search list when clicked outside
    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (searchListRef.current && !searchListRef.current.contains(event.target)) {
                setShowSearchList(false);
            }
        };

        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);

    useEffect(() => {
        function handleClickOutside(event) {
          if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsDropdownVisible(false);
            setSearchTerm("")
          }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }, [])

        useEffect(() => {
        const agactiveuserlist = () => {
            let l = []
            for (let i = 0; i < aguserStore.list.length; i++) {
                let e = aguserStore.list[i]
                if (e['status'] == "ACTIVE" && e['email'].indexOf(`@${process.env.REACT_APP_ENTERPRISE_DOMAIN}`) != -1) {
                    l.push(
                        {
                            label: aguserStore.getName4email(e['email']),
                            value: aguserStore.getName4email(e['email'])
                        }
                    )
                }
            }
            if (JSON.stringify(agActiveList) != JSON.stringify(l)) {
                setAgActiveList(l)
            }
        }
        agactiveuserlist()
            let v = {
                vertical: "all",
                division: "all",
            }
            AguserApi.getbranchesForTypes(v, setbranchesForTypes)
    }, [aguserStore.list])  


    useSnapshot(loginStore)
    useSnapshot(bookingsStore)
    useSnapshot(contractsStore)
    useSnapshot(configStore)
    useSnapshot(entityStore)
    let brec = bookingsStore.current
    console.log("brec---------->", brec)
    const aguser = loginStore.userRec.aguserRec
    const [hasToAutoPopulateEntityDetail, setHasToAutoPopulateEntityDetail] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [pendingValue, setPendingValue] = useState(false);
    const [options, setOptions] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredOptions, setFilteredOptions] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [isDropdownVisible, setIsDropdownVisible] = useState(false);
    const [flexiBooking, setFlexiBooking] = useState(process.env.REACT_APP_ENTERPRISE_NAME_SMALLCASE === 'agraga');
    const [isNomination ,setIsNomination] = useState(false)
    const stype = () => brec.contract.shipmentType.toUpperCase().substr(0, 3)
    const FCL_EXPORT_BOOKING = stype() === 'FCL' && (brec?.contract?.tradeType === "Export");
    const FCL_EXPORT_BOOKING_SHIPPER_PDA = stype() === 'FCL' && brec?.contract?.tradeType === "Export" && brec?.contract?.portOfReceipt !== brec?.contract?.portOfLoading;
    const FCL_EXPORT_BOOKING_CARRIERMBL = stype() === 'FCL' && brec?.contract?.tradeType === "Export" && contractsStore.current.shipmentScope.endsWith('ort');
  
    const handleFlexiBooking = () => {        
        setFlexiBooking(prev => !prev)
        setShipperSearch('')
        setConsigneeForm(false)
        delete brec.shipperCompany
        delete brec.shipperAddress
        setSelectedUserId('')
        setSelectedShipperUserId('')
        setShipperDetails({ firstName: "", lastName: "", emailId: "", mobileNumber: "", companyName: "", country: shipperDetails.country, address: "", pincode: "", city: "", state: "", newShipper: false, linkedEntity: "" })}

  
    const handleHSNSearch = (e) => {
        const term = e.target.value;
        setSearchTerm(term);
    
        if (term.length >= 3) {
            const filtered = options.filter((item) => {
                const typeName = String(item.commodityTypeName || "");
                const description = String(item.commodityDescription || "");
                
                return (
                    typeName.toLowerCase().includes(term.toLowerCase()) ||
                    description.toLowerCase().includes(term.toLowerCase())
                );
            });
            setFilteredOptions(filtered);
            setIsDropdownVisible(true);
        } else {
            setIsDropdownVisible(false);
        }
    };
  
    // Handle Option Selection
    const handleSelect = (item) => {
      if (!selectedItems.some((selected) => selected.id === item.id)) {
        setSelectedItems([...selectedItems, item]);
      }
      setSearchTerm("");
      setValidHSN(true);
      setIsDropdownVisible(false); // Close dropdown on selection
    };
  
   
    const handleRemoveTag = (id) => {
      const updatedItems = selectedItems.filter((item) => item.id !== id);
      setSelectedItems(updatedItems);
    };

    const filteredShipperList = shipperList?.filter(shipper =>
        shipper.companyName?.toLowerCase().includes(shipperSearch?.toLowerCase())
    );

    useEffect(() => {

      if(contractsStore.current.shipmentType.toLowerCase().includes('lcl')){
            setBlType("Seaway")
        }
        const fetchExcelFile = async () => {
            try {
                const response = await fetch("/HSN Code.xlsx");
                if (!response.ok) {
                    throw new Error(`Failed to fetch file: ${response.statusText}`);
                }
        
                const arrayBuffer = await response.arrayBuffer();
                const data = new Uint8Array(arrayBuffer);
        
                const workbook = XLSX.read(data, { type: "array" });
                const sheetName = workbook.SheetNames[0];
                const sheet = workbook.Sheets[sheetName];
                const jsonData = XLSX.utils.sheet_to_json(sheet);
               
                const parsedData = jsonData.map((row) => ({
                    id: row.id,
                    commodityTypeName: row.commodity_type_name,
                    commodityDescription: row.commodity_description,
                }));
        
                setOptions(parsedData); 
            } catch (error) {
                console.error("Error parsing Excel file:", error);
            }
        };
        if(contractsStore.current.shipmentType.toLowerCase().includes('fcl')){
        fetchExcelFile();
        }
    }, []);

    useEffect(() => {
        async function setbookingdata() {
            if(ServerLists.countryList.length<10){
                Api.loadCountryList()
            }
            // EntityApi.getList();
            if (contractsStore.current.incoTerms &&
                contractsStore.current.incoTerms.length > 0)
                setIncoEditable(false)
            if (contractsStore.current.commodityType &&
                contractsStore.current.commodityType.length > 0)
                setCtypeEditable(false)
            if (loginStore.isClient()) {
                brec.firstName = aguser.firstName
                brec.lastName = aguser.lastName
                brec.phone = aguser.phone
                brec.emailid = loginStore.email
            }
            brec.incoTerms = contractsStore.current.incoTerms
            brec.commodityType = contractsStore.current.commodityType
            brec.carrierMBL = ''
            brec.entityId = brec.contract.entityId
            // if(contractsStore.current.carrierMBL){
            //     brec.carrierMBL = contractsStore.current.carrierMBL
            // }else{
            //     brec.carrierMBL = 'No'
            // }

            // const entity = EntityV2Store.list.find(e1 => {
            //     return e1.entityId === brec.contract.entityId
            // })
            let entity = await EntityV2Api.viewEntity(brec.contract.entityId, setentityData)
            console.log("entity", entity);            

            if (!entity) {
                // setCompanyName(brec.contract.gst);
                return;
            }
            let fromLoc = brec.contract.shipmentType.toLowerCase().includes('air') ?
                Utils.extractCodeAndReturnCountry(brec.contract.originAirport)
                : Utils.extractCodeAndReturnCountry(brec.contract.portOfReceipt)
            // let fpodCountry = brec.contract.finalPlaceOfDelivery.substring(brec.contract.portOfReceipt.indexOf(',')+1,brec.contract.portOfReceipt.indexOf("(")).trim();

            // if (fromLoc.toLowerCase().includes(entity.entityCountry?.toLowerCase())) {
            setHasToAutoPopulateEntityDetail(true);
            brec.company = entity.entityName
            setCompanyName(entity.entityName)
            // brec.branchId=entity.branch[0].branchId
            // brec.address = entity.branch[0].branchAddresses[0].address
            brec.country = entity.branch[0].country
            // brec.pin = entity.branch[0].branchAddresses[0].pincode
            // setaddressObj(JSON.stringify(entity.branch[0].branchAddresses[0]))
            // }
            // else {
            // setHasToAutoPopulateEntityDetail(true);
            // brec.company = entity.entityName
            // setCompanyName(entity.entityName)
            // brec.branchId=entity.branch[0].branchId
            // brec.address = entity.branch[0].branchAddresses[0].address
            // brec.country = entity.branch[0].country
            // brec.pin = entity.branch[0].branchAddresses[0].pincode
            // setaddressObj(JSON.stringify(entity.branch[0].branchAddresses[0]))
            // }
            // if(hasToAutoPopulateEntityDetail){
            //     brec.company = brec.contract.gst
            //     console.log('GOT COMPANY AS ========', brec.company, entityStore.list.length)
            //     const ent = entityStore.list.filter(e1 => e1.gst === brec.company)
            //     if (ent.length > 0) {
            //         let entity = ent[0]
            //         console.log('entity found =', entity)
            //         setCompanyName(entity.entityName)
            //         brec.address = entity.address
            //         brec.country = entity.country
            //         brec.pin = entity.pinCode
            //     } else {
            //         setCompanyName(brec.contract.gst)
            //     }
            // }
            console.log('******urgentbooking', brec)
        }
        setbookingdata()

    }, [brec, aguser.firstName, aguser.lastName, aguser.phone])

    useEffect(() => {
        let brec = bookingsStore.current
        let entityId = brec.contract?.entityId
        if (!loginStore.isClient()) {
            BranchApi.getAllBranches(entityId, (data) =>
                setbranches(data)
            )
        } else {
            let entity = loginStore.userRec.companyList.filter((x, i) => x.entityId === configStore.currentSelectedEntity.entityId);
            let branch = entity[0].branches
            setbranches(branch)
        }
        Api.getContract(contractsStore.current.contractRefNum, (data) => {
            brec.premium = data.premium
            brec.sum_insured = data.sum_insured
            brec.insurance_Amount = data.insurance_Amount
            brec.insuranceusd = data.insuranceusd
        })

    }, [])

    useEffect(()=> {
     if(branches?.length === 1){
        brec.branchId = branches[0].branchId
        brec.entityId = brec.contract.entityId
        brec.address = ""
        brec.pin = ""
        setaddressObj({})
        setvalidbranch(true)
         if(branches[0]?.branchAddresses?.length === 1 && branches[0]?.branchAddresses[0]?.address?.length > 0 ){
             let object = branches[0]?.branchAddresses[0]
             let data = object
             brec.address = data.address
             brec.pin = data.pincode || data.zipcode
             setaddressObj(JSON.stringify(object))
             setvalidAddress(true)        
             if (brec.salesperson == undefined || (brec.salesperson != undefined && brec.salesperson.length == 0)) {
                 let tradeType = Utils.getTradeType({
                     rec: brec.contract,
                     shipmentType: brec.contract.shipmentType,
                     entityCountry: entityData.entityCountry
                 })
                 let rmList = branches[0]?.crossBorder.relationshipManagers
                 let nomination = brec.contract.nomination
                 let rmemails = Utils.getRelationShipMangerForType(rmList, brec.contract.shipmentType, tradeType, nomination);
                 //   let rmemails = Utils.getRelationShipMangerForType(rmEmailList , "LCL" , "import" );
                 if (rmemails.length > 0 && rmemails[0]?.email?.length > 0) {
                     // brec.current.salesperson = aguserStore.getName4email(rmemails[0].email);
                     brec.salesperson = aguserStore.getName4email(rmemails[0].email);
                     setisRMAvailable(true)
                 }
                 else {
                     brec.salesperson = "";
                     setisRMAvailable(false)
                 }
             }
             if (brec.customerService == undefined || (brec.customerService != undefined && brec.customerService.length == 0)) {
                 let tradeType = Utils.getTradeType({
                     rec: brec.contract,
                     shipmentType: brec.contract.shipmentType,
                     entityCountry: entityData.entityCountry
                 })
                 let csList = branches[0]?.crossBorder.customerService
                 let nomination = brec.contract.nomination
                 let csemails = Utils.getCustomerServiceForType(csList, brec.contract.shipmentType, tradeType, nomination);                
                 if (csemails.length > 0 && csemails[0]?.email?.length > 0) {                  
                     brec.customerService = aguserStore.getName4email(csemails[0].email);              
                     setiCSAvailable(true)
                 } else {
                     brec.customerService = aguserStore.getName4email(csemails[0].email);
                     setiCSAvailable(false)
                 }
             }  
         }
     }
    
    },[branches])
    let pincodeRegex;

    if (shipperDetails.country === "India") {
        pincodeRegex = /^\d{0,6}$/;
    } else {
        pincodeRegex = /^\d{0,10}$/;
    }

    const handlePincodeChange = (e) => {
        const { value } = e.target;
        if (pincodeRegex.test(value)) {
            setShipperDetails({ ...shipperDetails, pincode: e.target.value })
        }
    };

    const handleToggle = (val) => {
        if (val === "Yes") {
            setPendingValue(val);
            setShowConfirm(true);
        } else {
            brec.carrierMBL = val;
        }
    };

    const confirmToggle = () => {
        brec.carrierMBL = pendingValue;
        setShowConfirm(false);
    };

    const cancelToggle = () => {
        brec.carrierMBL = "No"
        setShowConfirm(false);
    };   
    
    const renderLink = (fileName) => {
        if (fileName && fileName.length > 3) {
            return (
                <a href={process.env.REACT_APP_FILE_SERVER + '/clientfiles/' + fileName} target="_blank">{fileName}</a>
            )
        } else return <></>
    }
    const filecat = '' + Date.now()
    let commList = commodityList
    if (brec.contract.hazardous === 'Yes') commList = hazardousList
    

    const setBranchfn = (e) => {
        brec.branchId = e.target.value
        brec.entityId = brec.contract.entityId
        brec.address = ""
        brec.pin = ""
         let selectedbranch = branches?.filter((r, i) => r.branchId === brec.branchId)
        if (selectedbranch[0]?.branchAddresses?.length === 1) {
            let data = selectedbranch[0]?.branchAddresses[0]
            brec.address = data.address
            brec.pin = data.pincode || data.zipcode
            setaddressObj(JSON.stringify(selectedbranch[0]?.branchAddresses[0]))
            setvalidbranch(true)
            if (brec.salesperson == undefined || (brec.salesperson != undefined && brec.salesperson.length == 0)) {
                let tradeType = Utils.getTradeType({
                    rec: brec.contract,
                    shipmentType: brec.contract.shipmentType,
                    entityCountry: entityData.entityCountry
                })
                let rmList = selectedbranch[0]?.crossBorder.relationshipManagers
                let nomination = brec.contract.nomination
                let rmemails = Utils.getRelationShipMangerForType(rmList, brec.contract.shipmentType, tradeType, nomination);
                //   let rmemails = Utils.getRelationShipMangerForType(rmEmailList , "LCL" , "import" );
                if (rmemails.length > 0 && rmemails[0]?.email?.length > 0) {
                    brec.salesperson = aguserStore.getName4email(rmemails[0].email);
                    setisRMAvailable(true)
                }
                else {
                    brec.salesperson = "";
                    setisRMAvailable(false)
                }
            }
            if (brec.customerService == undefined || (brec.customerService != undefined && brec.customerService.length == 0)) {
                let tradeType = Utils.getTradeType({
                    rec: brec.contract,
                    shipmentType: brec.contract.shipmentType,
                    entityCountry: entityData.entityCountry
                })
                let csList = selectedbranch[0]?.crossBorder.customerService
                let nomination = brec.contract.nomination
                let csemails = Utils.getCustomerServiceForType(csList, brec.contract.shipmentType, tradeType, nomination);
                let k = []
                if (csemails.length > 0 && csemails[0]?.email?.length > 0) {       
                    brec.customerService = aguserStore.getName4email(csemails[0].email);
                    setiCSAvailable(true)
                } else {
                    brec.customerService = aguserStore.getName4email(csemails[0].email);
                    setiCSAvailable(false)
                }
            }  
        }else{
        setaddressObj({})
        setvalidbranch(true)
        }               

    }

    const checkSingleBranch = ()=> {
        if(branches?.length === 1){
          return true  
        }
        return false
    }
      const checkSingleBranchAddress = ()=> {
        if(checkSingleBranch() && branches[0]?.branchAddresses?.length === 1 && branches[0]?.branchAddresses[0]?.address?.length > 0 ){
          return true  
        }
        return false
    }
    const handleSearchChange = (e) => {
        if (e.target.value) { setNewShipper(true) }
        else {
            setNewShipper(false)
            setShipperDetails({ ...shipperDetails, firstName: "", lastName: "", emailId: "", mobileNumber: "", companyName: "", address: "", pincode: "", city: "", state: "", newShipper: false, linkedEntity: "" })
        }
        setShipperSearch(e.target.value);
        setShowSearchList(true);
    };
    const handleEmailChange = ((e) => {
        bookingsStore.linkedEntity = '';
        setShipperDetails({ ...shipperDetails, emailId: e.target.value , linkedEntity: '' })
        getEntity(e.target.value)
    }
    )

    const setAddressFn = (r, i) => {
        console.log(r, i);
        if (r.target.value !== "") {
            let data = JSON.parse(r.target.value)
            brec.address = data.address
            brec.pin = data.pincode || data.zipcode
            setaddressObj(r.target.value)
            setvalidAddress(true)
        }

    }
    const getEntity = async (email) => {
      const domain = process.env.REACT_APP_ENTERPRISE_DOMAIN; 
    const escapedDomain = domain.replace('.', '\\.');

    const emailRegex = new RegExp(`^[^\\s@]+@(?!${escapedDomain}$)[^\\s@]+\\.[^\\s@]+$`, 'i');
    const emailRegexOnlyAgraga = new RegExp(`^[^\\s@]+@${escapedDomain}$`, 'i');


        if (emailRegexOnlyAgraga.test(email)) {
            setShipperDetails(prevState => ({ ...prevState, emailId: "" }));
        }
        if (!emailRegex.test(email)) {
            return;
        }

        try {

            EntityV2Api.GetEntityListWithEmail(email, brec.entityId, (response) => {
                if (response?.data?.length > 0) {
                    setEntityList(response?.data)
                    setshowList(true)
                } else if (response?.errors) {
                    setShipperDetails(prevState => ({ ...prevState, emailId: "" }));
                    configStore.setModalMessage(response?.errors)
                }

            });
        } catch (error) {
            console.log(error);
        }
    }
    const handleEntitySelect = (entityId) => {
        setShipperDetails({ 
            ...shipperDetails,
            linkedEntity: entityId 
        })
    };


    useEffect(() => {
        brec.originCount = brec.contract.shipmentType.toLowerCase().includes('air') ?
        Utils.extractCodeAndReturnCountry(brec.contract.originAirport)
        : Utils.extractCodeAndReturnCountry(brec.contract.portOfReceipt)
        brec.destinationCount = Utils.extractCodeAndReturnCountry(brec.contract?.finalPlaceOfDelivery)
        setCecOc(brec.country === brec.originCount);
        setCecOd(brec.country === brec.destinationCount);
        setShipperDetails({ ...shipperDetails, country: cecOc ? brec.destinationCount : brec.originCount })
        cecOc && setConsigneeForm(false)
    }, [brec.country, brec.contract.origin, brec.contract.destination, brec.entityId, cecOc, cecOd, brec]);
    useEffect(() => {
        if (shipperDetails.country) {
            const fetchShipperData = async () => {
                try {
                    const res = await ShipperApi.getShipper(brec.entityId, shipperDetails.country);
                    setShipperList(res.data);
                } catch (error) {
                    console.error(error);
                }
            };
            fetchShipperData();
        }
    }, [shipperDetails.country]);

    const extractCleanPhone = (user) => {
        let raw = (user.phoneNum || user.phone || user.mobile || user.mobileNumber || "").toString().replace(/\D/g, "");
        if (raw.length === 12 && raw.startsWith("91")) {
            raw = raw.slice(2);
        } else if (raw.length > 10 && raw.startsWith("91")) {
            raw = raw.slice(2);
        }
        return raw;
    };

    useEffect(() => {
        const entityId = brec.contract?.entityId || brec.entityId;
        if (entityId) {
            Newapi.allEntityUsers(entityId, (users) => {
                if (Array.isArray(users)) {
                    setEntityUsers(users);
                }
            });
        }
    }, [brec.contract?.entityId, brec.entityId]);

    useEffect(() => {
        if (shipperDetails.linkedEntity) {
            Newapi.allEntityUsers(shipperDetails.linkedEntity, (users) => {
                if (Array.isArray(users)) {
                    setShipperEntityUsers(users);
                }
            });
        } else {
            setShipperEntityUsers([]);
            setSelectedShipperUserId('');
        }
    }, [shipperDetails.linkedEntity]);

    useEffect(() => {
        if (entityUsers.length > 0 && !selectedUserId) {
            const currentEmail = ((cecOc || cecOd) ? brec.emailid : shipperDetails.emailId) || "";
            if (currentEmail) {
                const matched = entityUsers.find(u => 
                    (u.email && u.email.toLowerCase() === currentEmail.toLowerCase()) ||
                    (u.emailId && u.emailId.toLowerCase() === currentEmail.toLowerCase()) ||
                    (u.emailid && u.emailid.toLowerCase() === currentEmail.toLowerCase())
                );
                if (matched) {
                    setSelectedUserId(matched._id || matched.id || matched.email);
                }
            }
        }
    }, [entityUsers, brec.emailid, shipperDetails.emailId, cecOc, cecOd, selectedUserId]);

    const handleContactUserChange = (e) => {
        const userId = e.target.value;
        setSelectedUserId(userId);
        const user = entityUsers.find(u => (u._id === userId || u.id === userId || u.email === userId));
        if (user) {
            const firstName = user.firstName || "";
            const lastName = user.lastName || "";
            const email = (user.email || user.emailId || user.emailid || "").trim();
            const phone = extractCleanPhone(user);

            if (cecOc || cecOd) {
                brec.firstName = firstName;
                brec.lastName = lastName;
                brec.emailid = email;
                brec.phone = phone;
            }
            setShipperDetails(prev => ({
                ...prev,
                firstName,
                lastName,
                emailId: email,
                mobileNumber: phone
            }));
            setValidMobile(true);
        } else {
            if (cecOc || cecOd) {
                brec.firstName = "";
                brec.lastName = "";
                brec.emailid = "";
                brec.phone = "";
            }
            setShipperDetails(prev => ({
                ...prev,
                firstName: "",
                lastName: "",
                emailId: "",
                mobileNumber: ""
            }));
        }
    };

    const handleShipperUserChange = (e) => {
        const userId = e.target.value;
        setSelectedShipperUserId(userId);
        const user = shipperEntityUsers.find(u => (u._id === userId || u.id === userId || u.email === userId));
        if (user) {
            const firstName = user.firstName || "";
            const lastName = user.lastName || "";
            const email = (user.email || user.emailId || user.emailid || "").trim();
            const phone = extractCleanPhone(user);

            setShipperDetails(prev => ({
                ...prev,
                firstName,
                lastName,
                emailId: email,
                mobileNumber: phone
            }));
            setValidMobile(true);
        } else {
            setShipperDetails(prev => ({
                ...prev,
                firstName: "",
                lastName: "",
                emailId: "",
                mobileNumber: ""
            }));
        }
    };

    function checkSelectedBranch() {
        let selectedbranch = entityData.branch.filter((r, i) => r.branchId === brec.branchId)
        return selectedbranch[0]
        //  entityData.branch
    }
    function validEmail(email) {
        // Regular expression pattern for validating email addresses
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(email);
    }
    const delFile = (a,ind)=>{
        let l = []
        for (let i = 0; i < a.length; i++) {
            if(i!=ind){
                l.push(a[i])
            }
        }
        return l
    }
    const [faberror,setFbaerror] = useState([])
    const onSubmit = () => {
        brec.flexiBooking = !flexiBooking
        setButtonClicked(true)
        shipperDetails.companyName = shipperSearch
        shipperDetails.newShipper = newShipper
        if (cecOc){
            shipperDetails.role = "consignee"
            brec.consignee = shipperSearch
            brec.shipper = brec.company
        }else{
            shipperDetails.role = "shipper"
            brec.shipper = shipperSearch
            cecOd?brec.consignee = brec.company: brec.consignee = ""

        }
         brec.contract.volumeInDimensions = enquiryStore.current.volumeInDimensions ?? true
        setbuttonClickedAtleastOnce(true)
        setButtonClicked(true);
        let hasError = false
         if(!flexiBooking && (!shipperDetails.companyName || !brec.shipperCompany)){
            hasError = true
        }
        if ((flexiBooking) &&(((cecOd && !cecOc) || (!cecOd && !cecOc)) && !shipperDetails.companyName)) {
            hasError = true
            setButtonClicked(false)
        }
        if(FCL_EXPORT_BOOKING){
            if (selectedItems?.length < 1) {
                hasError = true
                setValidHSN(false)
            }
            if (!brec.etd_at_pol || brec.etd_at_pol.length < 1) {
                hasError = true
                setEtdAtPol(false)
            }
        }
        if ((FCL_EXPORT_BOOKING && (!blType || blType.length < 1)) || (stype() === 'LCL' && (!blType || blType.length < 1))) {
            hasError = true
            setValidBLTypes(false)
        }
        if (FCL_EXPORT_BOOKING_SHIPPER_PDA && (!shipperPDA || shipperPDA.length < 1)) {
                hasError = true
                setPDA(false)
            }
        if(FCL_EXPORT_BOOKING_CARRIERMBL && (!brec.carrierMBL || brec.carrierMBL.length < 1)){
            hasError = true
            setValidCarrierMBL(false)
        }
        if (!brec.incoTerms || brec.incoTerms.length < 1) {
            setValidIncoterms(false)
            hasError = true
        } else { setValidIncoterms(true) }
        if (!brec.commodityType || brec.commodityType.length < 1) {
            setValidCommodityType(false)
            hasError = true
        } else { setValidMobile(true) }
        if ((flexiBooking) &&(!(!cecOc && !cecOd) && (!brec.phone || brec.country !== "India"? (brec.phone.length < 7):(brec.phone.length !== 10)))) {
            setValidMobile(false)
            hasError = true
        } else { setValidMobile(true) }
        if (brec.contract.hazardous === 'Yes') {
            if (!brec.iipcert_filename || brec.iipcert_filename.length < 1) {
                setValidIIPCertificate(false)
                hasError = true
            } else {
                setValidIIPCertificate(true)
            }
        }
        if (TenantUtils.isAgraga() && (brec.contract.hazardous === 'Yes' || brec.contract.temperatureControlled === "Yes")){
        if (!brec.commercialInvoice_filename_list || brec.commercialInvoice_filename_list.length < 1) {
            setValidCommercialInvoice(false)
            hasError = true
        } else {
            setValidCommercialInvoice(true)
        }
        if (!brec.packingList_filename_list || brec.packingList_filename_list.length < 1) {
            setValidPackingList(false)
            hasError = true
        } else {
            setValidPackingList(true)
        }}
        if (!brec.branchId || brec.branchId.length < 1) {
            // configStore.setModalMessage('Please select branch address')
            setvalidbranch(false);
            hasError = true

        } else { setvalidbranch(true) }
        if (!brec.address || brec.address.length < 1) {
            // configStore.setModalMessage('Please select branch address')
            setvalidAddress(false);
            hasError = true

        } else { setvalidAddress(true) }
        if (hasError) {
            setButtonClicked(false);
            return
        }
        if ((flexiBooking) &&(!(!cecOc && !cecOd) && (!brec.firstName || brec.firstName.length < 1))) {
            // configStore.setModalMessage('First Name is Mandatory')
            setButtonClicked(false);
            return
        }
        if ((flexiBooking) &&(!(!cecOc && !cecOd) && (!brec.emailid || brec.emailid.length < 1 || !validEmail(brec.emailid)))) {
            // configStore.setModalMessage('Email is Mandatory')
            setButtonClicked(false);
            return
        }

        if ((flexiBooking) &&(!(!cecOc && !cecOd) && (!brec.company))
            // || !brec.address || !brec.pin || !brec.country
        ) {
            // configStore.setModalMessage('Please enter all company details')
            // configStore.setModalMessage('Please enter shipper name.')
            setButtonClicked(false)
            return
        }
        if ((flexiBooking) &&(!brec.country)) {
            // configStore.setModalMessage('Please enter all company details')
            // configStore.setModalMessage('Please select country.')
            setButtonClicked(false)
            return
        } if ((flexiBooking) &&(!brec.pin)) {
            // configStore.setModalMessage('Please enter all company details')
            if (entityData.entityCountry.toLowerCase() === 'india') {
                // configStore.setModalMessage('Please Enter PinCode')
            } else {
                // configStore.setModalMessage('Please Enter ZipCode')
            }

            setButtonClicked(false)
            return
        }
        if(brec.fba=='Yes'){
            brec.contract.warehouse = enquiryStore.current.warehouse
            let e = []
            if(brec?.merchantID?.length>14){
                configStore.setModalMessage(`Merchant ID 14 characters Only.`);
                e.push("merchantID")
                hasError = true;
            }
            for (let i = 0; i < brec?.fbaDetails.length; i++) {
                for (let j = 0; j < brec?.fbaDetails[i].length; j++) {
                    if(process.env.REACT_APP_FBA_Mandatory != undefined && process.env.REACT_APP_FBA_Mandatory=='yes'){
                        if(brec?.fbaDetails[i][j].fbaID?.length==0){
                            configStore.setModalMessage(`FC ID is required and cannot be left blank.`);
                            e.push("fbaID"+i+j)
                            hasError = true;
                        }
                        if(brec?.fbaDetails[i][j].purchaseOrderID?.length==0  && brec.contract.warehouse === 'AMAZON'){
                            configStore.setModalMessage(`Amazon Reference ID is required and cannot be left blank.`);
                            e.push("purchaseOrderID"+i+j)
                            hasError = true;
                        }
                        if(brec?.fbaDetails[i][j].poExpiryDate== undefined || brec?.fbaDetails[i][j].poExpiryDate?.length==0){
                            configStore.setModalMessage(`PO Issuance Date is required and cannot be left blank.`);
                            e.push("poExpiryDate"+i+j)
                            hasError = true;
                        }
                    }
                    // if(brec?.fbaDetails[i][j].fbaID?.length>12){
                    //     configStore.setModalMessage(`FBA ID Maximum 12 characters Only.`);
                    //     e.push("fbaID"+i+j)
                    //     hasError = true;
                    // }
                    if(brec?.fbaDetails[i][j].purchaseOrderID?.length>8){
                        configStore.setModalMessage(`Amazon Reference ID Maximum 8 characters Only.`);
                        e.push("purchaseOrderID"+i+j)
                        hasError = true;
                    }
                }
            }
            if(JSON.stringify(e)!=JSON.stringify(faberror)){
                setFbaerror(e)
            }
            if(hasError){
                setButtonClicked(false);
                return;
            }
        }
        if(TenantUtils.isAgraga()){
        if(brec.commercialInvoice_filename_list.length>0 && brec.packingList_filename_list.length==0){
            if(validPackingList){
                setValidPackingList(false)
            }
            setButtonClicked(false);
            return;
        }else{
            if(!validPackingList){
                setValidPackingList(true)
            }
        }
        if(brec.commercialInvoice_filename_list.length==0 && brec.packingList_filename_list.length>0){
            if(validCommercialInvoice){
                setValidCommercialInvoice(false)
            }
            setButtonClicked(false);
            return;
        }else{
            if(!validCommercialInvoice){
                setValidCommercialInvoice(true)
            }
        }
        }
        if (shipperDetails.companyName && !brec.flexiBooking) {
            if (!shipperDetails.address) {
                configStore.setModalMessage(`${shipperDetails.role} Address is required.`);
                hasError = true;
            } else if (!shipperDetails.city) {
                configStore.setModalMessage(` ${shipperDetails.role} City is required.`);
                hasError = true;
            } else if (!shipperDetails.companyName) {
                configStore.setModalMessage(`${shipperDetails.role} Company name is required.`);
                hasError = true;
            } else if (!shipperDetails.country) {
                configStore.setModalMessage(`${shipperDetails.role} Country is required.`);
                hasError = true;
            } else if (!validEmail(shipperDetails.emailId)) {
                configStore.setModalMessage(`A valid ${shipperDetails.role} email is required.`);
                hasError = true;
            } else if (!shipperDetails.firstName) {
                configStore.setModalMessage(`${shipperDetails.role} First name is required.`);
                hasError = true;
            } else if (!shipperDetails.state) {
                configStore.setModalMessage(`${shipperDetails.role} State is required.`);
                hasError = true;
            } else if (!shipperDetails.pincode || shipperDetails.pincode.length < 3 || shipperDetails.pincode.length >= 15 ) {
                configStore.setModalMessage(`${shipperDetails.role} Pincode should be at least 3 digits and to the maximum 15.`);
                hasError = true;
            } else if (shipperDetails.country !== "India" && (shipperDetails.mobileNumber.length < 6 || shipperDetails.mobileNumber.length > 15)) {
                configStore.setModalMessage(`${shipperDetails.role} Mobile number should be between 6 and 15 digits.`);
                hasError = true;
            } else if (shipperDetails.country === "India" && shipperDetails.mobileNumber.length !== 10) {
                configStore.setModalMessage(`In India, ${shipperDetails.role} mobile number should be exactly 10 digits.`);
                hasError = true;
            }
            if (hasError) {
                setButtonClicked(false);
                return;
            }
        }
        if (!brec.flexiBooking) {
            brec.sendMilestoneAlert = milestoneAlert;
        }else{
            brec.sendMilestoneAlert = false
        }
        brec.paymentType = paymentType

        if(selectedItems.length > 0){
            brec.hsn = selectedItems
        }
        if(FCL_EXPORT_BOOKING_SHIPPER_PDA) brec.shipperPDA = shipperPDA
        if(stype() === 'LCL' || FCL_EXPORT_BOOKING) brec.blType = blType
        if(brec.contract.customerReferenceNum != enquiryStore.current.enqRoute.customerReferenceNum){
            brec.contract.customerReferenceNum = enquiryStore.current.enqRoute.customerReferenceNum
        }
        
        if (brec.commodityType && brec.commodityType.startsWith('Non-Hazardous Chemicals')) {
            if ((!brec.msds_filename || brec.msds_filename.length < 1) || (!brec.nondgdecl_filename || brec.nondgdecl_filename.length < 1)) {
                if (!configStore.hasToShowAgWarn && !isWarnAccepted) {
                    configStore.hasToShowAgWarn = true;
                    setButtonClicked(false);
                    return;
                }
            }
            // if (!brec.msds_filename || brec.msds_filename.length < 1) {
            //     configStore.setModalMessage('MSDS is Mandatory')
            //     return
            // }
            // if (!brec.nondgdecl_filename || brec.nondgdecl_filename.length < 1) {
            //     configStore.setModalMessage('Non-Haz Declaration is Mandatory')
            //     return
            // }
        }

        const callback = (d) =>{
            if(TenantUtils.isAgraga()){
            let rec = contractsStore.current
            let shipmentType = rec.shipmentType
            let entityCountry = EntityV2Store.EntityRec.entityCountry.toLowerCase()            
                let tradeType = Utils.getTradeType({
                    rec,
                    shipmentType,
                    entityCountry
                }) 
            let toUsers = Utils.getRespectiveMember(EntityV2Store.EntityRec.customer , shipmentType , tradeType  , rec.nomination )          
            let CustomerName = EntityV2Store.EntityRec.entityName
            let shipType = rec.shipmentType
            let shipScope = rec.shipmentScope
            let origin = rec.origin
            let destination = rec.destination            
            let from = `${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE} <${process.env.REACT_APP_SUPPORTMAIL_ID}>`
            let to = toUsers
            if (url.indexOf(`booking.${process.env.REACT_APP_ENTERPRISE_DOMAIN}`) >= 0) {
                to = to + `,sanjeev.gupta@${process.env.REACT_APP_ENTERPRISE_DOMAIN}`
            }
            let subject = 'Booking - ' + configStore.bookingModalNum
            if(EntityV2Store.EntityRec?.customer?.crossBorder?.salesVertical?.trim() == 'MSME' && contractsStore.current?.customerReferenceNum) subject = subject+' // CRN: '+ contractsStore.current?.customerReferenceNum
            let message = `Hi Team,<br />
            <br />
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; We have received a booking from ${CustomerName}.<br />
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;     Booking Number: ${d._id}.<br />
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;    Shipment Type: ${shipType}.<br />
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;    Scope :${shipScope}.<br />
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;    Origin: ${origin}.<br />`
            if(rec.multidest!=undefined && rec.multidest.length>1){
                            for (let i = 0; i < rec.multidest.length; i++) {
                                message=message+`&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;     Destination${i+1}: ${rec.multidest[i]['destination']}.<br />`
                            }
                        }else{
                        message=message+`&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;     Destination: ${destination}.<br />`
                        }
            message=message+`<br />
            Team ${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE}</p>`
            Api.sendClientMailwithoutMessage(from, to, subject, message)
            }
            loader.hide()
        }
        
        let role =[]
        //Ocean
        const entityDetails = contractsStore.current
        if(entityDetails.shipmentType !== 'Air' && cecOc){
            role.push('Ocean export Coordination')
        }
        if(entityDetails.shipmentType !== 'Air' && cecOd){
            role.push('Ocean Import Coordination')
        }
        if(entityDetails.shipmentType !== 'Air' && !cecOc && !cecOd ){
            role.push('Ocean export Coordination')
            role.push('Ocean Import Coordination')
        }
        //Air
        if(entityDetails.shipmentType === 'Air' && cecOc){
            role.push('Air export Coordination')
        }
        if(entityDetails.shipmentType === 'Air' && cecOd){
            role.push('Air Import Coordination')
        }
        if(entityDetails.shipmentType === 'Air' && !cecOc && !cecOd ){
            role.push('Air export Coordination')
            role.push('Air Import Coordination')
        }
        shipperDetails.toUsers =role

        let ccRoleVendor = []
        // ccRoleVendor.push(...role)

        if (entityDetails.shipmentType === SHIPMENT_TYPE.lcl)
            ccRoleVendor.push('LCL Procurement')
        else if (entityDetails.shipmentType === SHIPMENT_TYPE.air)
            ccRoleVendor.push('AIR Procurement')
        else
            ccRoleVendor.push('FCL Procurement')

        shipperDetails.ccVendorUsers =ccRoleVendor

        console.log("contractsStore",contractsStore.current)
       
        brec.insurance_Amount_currency_type="USD"
        loader.show()
        BookingsApi.saveBooking(shipperDetails,callback)
    };
    if(contractsStore.current.fba!=undefined && (brec.fba==undefined || contractsStore.current.fba!=brec.fba)){
        brec.fba=contractsStore.current.fba
    }
    const delfba = (ind1,ind2,fbaDetails) => {
        let l = JSON.parse(JSON.stringify(fbaDetails))
        let k = []
        for (let i = 0; i < l.length; i++) {
            let k1 = []
            if(i==ind1){
                for (let j = 0; j < l[i].length; j++) {
                    if(j!=ind2){
                        k1.push(l[i][j])
                    }
                }
                k.push(k1)
            }else{
                k.push(l[i])
            }
        }
        return k
    }
    
const handleFlexiBookingChange = (objectRef, key) => (e) => {
  objectRef[key] = e.target.value;
};

console.log("validate----->", {
        validBLTypes,
        validCarrierMBL,
        validEtdAtPol,
        validHSN,
        validPDA,
    })
    return (
        <>
        {
            (entityData!=undefined && entityData.branch!=undefined && entityData.branch.length>0)?
            <div style={{ fontSize: '0.8rem' }}>
                <BookingConfirmation />
                <AgWarnPopup callback={() => {
                    setIsWarnAccepted(true);
                    onSubmit();
                }}>
                    <p className="is-size-7">&emsp;&emsp;{MSDS_AND_DG_FILE_MISSING_WARN}</p>
                </AgWarnPopup>
                {
                    bookingsStore.current?.hasToShowDummySchedule ? <DummySchedulev3 stype={stype()} viewonly={true} dummyContract={bookingsStore.current.contract}/>
                        : stype() === 'LCL' ?
                            <LCLScheduleCompv3 data={bookingsStore.current.schedule} viewonly={true} current={bookingsStore.current.contract}/> :
                            stype() === 'FCL' ?
                                <FCLScheduleCompv3 data={bookingsStore.current.schedule} viewonly={true} contract={bookingsStore.current.contract}/> :
                                <AirScheduleCompv3 dummyContract={bookingsStore.current.contract}/>
                }
                <br />
                <InternalV3 autosave={true}/>
                       
                {process.env.REACT_APP_ENTERPRISE_NAME_SMALLCASE === 'agraga' && <div>
               <h2 style={{ paddingTop: "10px", fontSize: "1rem", fontWeight: "bold" }}>
  Do you need a flexible booking?
</h2>

<$c n="3">
  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
    <div onClick={handleFlexiBooking} style={{ cursor: 'pointer' }}>
      <img
        src={!flexiBooking ? on : off}
        alt={flexiBooking ? "Off" : "On"}
        style={{ width: "40px", height: "24px" }}
      />
    </div>
    <span>{flexiBooking ? 'No' : 'Yes'}</span>
  </div>
</$c></div>}

                       {flexiBooking? <div>
                <div>
                    <h2 style={{ paddingTop: "10px", fontSize: "1rem", fontWeight: "bold" }}>Shipper / Exporter details {cecOc && ' - Invoicing'}</h2>
                    <div className="columns" style={{ paddingTop: "10px" }}>
                        <$cr n='2'>Shipper Name</$cr>
                        <$c n='3'>
                            <div className={`select is-small ${(!buttonClickedAtleastOnce || (cecOc ? true : shipperDetails.state)) ? '' : 'is-danger'}`} >
                                <input
                                    type="text"
                                    className={`input is-small${(!buttonClickedAtleastOnce || (cecOc ? true : shipperDetails.state)) ? '' : 'is-danger'}`}
                                    placeholder="Search Shipper"
                                    value={cecOc ? brec.company : shipperSearch}
                                    onChange={handleSearchChange}
                                    disabled={cecOc}
                                    onClick={() => setShowSearchList(true)}
                                />
                                <ul>
                                    {showSearchList && !cecOc && (
                                        <div className="select-menu" style={{ position: 'absolute', top: '100%', left: 0, zIndex: 999, backgroundColor: 'white', border: '1px solid #ccc', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', padding: '0.5rem' }} ref={searchListRef}>
                                            <ul>
                                                {filteredShipperList?.map((shipper, index) => (
                                                    <li key={index} onClick={() => {
                                                        setNewShipper(false)
                                                        if (cecOc) {
                                                            brec.company = shipper.companyName;
                                                        } else {
                                                            setShipperDetails(shipper);
                                                            setShipperSearch(shipper.companyName);
                                                        }
                                                        setShowSearchList(false);
                                                    }}>
                                                        {shipper.companyName}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </ul>
                            </div>
                        </$c>
                                    
                    </div>
                    {cecOc ?
                        (<div className="columns">
                            <$cr n='2'>Branch *{space}</$cr>
                            <$c n='3'>
                                <div className={`select wd_100 ${validbranch ? '' : 'is-danger'}`}>
                                    <select className={`select is-fullwidth is-small ${validbranch ? '' : 'is-danger'}`} value={brec.branchId} onChange={(e) => setBranchfn(e)}
                                    //   disabled={checkSingleBranch()} 
                                    >
                                        <option value="" >Select Branch</option>
                                        {
                                            branches?.map((r, i) => {
                                                return (<option value={r.branchId}>{`${r.state?.split("/")[0]} - ${(r.gst.length > 0 ? r.gst : r.tinNum)}`}</option>)
                                            })
                                        }
                                        {/* <option>hyh</option> */}
                                    </select>
                                </div>
                            </$c>

                        </div>) : null
                    }
                    <div className="columns">

                        <$cr n='2'>Address *</$cr>
                        <$c n='3'>
                            {
                                (hasToAutoPopulateEntityDetail && cecOc) ?
                                    <div className={` select wd_100 ${!buttonClickedAtleastOnce || validAddress ? '' : 'is-danger'}`}>
                                        <select className={`wd_100 p-1 select is-fullwidth is-small ${cecOc ? validAddress : true ? '' : 'is-danger'}`} value={addressObj}
                                            onChange={cecOc ? (r, i) => setAddressFn(r, i) : ((e) => setShipperDetails({ ...shipperDetails, address: e.target.value }))} disabled={!cecOc && !newShipper}
                                        // brec.pin   = e.target.value 
                                        // console.log(i)
                                        >{<option value=''>select address</option>}{checkSelectedBranch()?.branchAddresses?.map((r, i) => <option key={i} value={JSON.stringify(r)} >{r.address}</option>)}</select></div> : <textarea className={`textarea wd_100 ${!buttonClickedAtleastOnce || cecOc ? validAddress : shipperDetails.address ? '' : 'is-danger'}`} value={cecOc ? brec.address : shipperDetails.address}
                                            disabled={!cecOc && !newShipper} onChange={cecOc ? ((e) => { brec.address = e.target.value; setvalidAddress(true); }) : ((e) => setShipperDetails({ ...shipperDetails, address: e.target.value }))}
                                    />
                            }
                        </$c>
                    </div>
                    {(cecOc || (!cecOc && shipperEntityUsers.length > 0)) && (
                        <div className="columns" style={{ paddingTop: "10px" }}>
                            <$cr n='2'>Contact Person *</$cr>
                            <$c n='3'>
                                <div className={`select wd_100 is-small ${(!buttonClickedAtleastOnce || (cecOc ? selectedUserId || (brec.firstName && brec.emailid) : selectedShipperUserId || (shipperDetails.firstName && shipperDetails.emailId))) ? '' : 'is-danger'}`}>
                                    <select
                                        className="select is-fullwidth is-small wd_100"
                                        value={cecOc ? selectedUserId : selectedShipperUserId}
                                        onChange={cecOc ? handleContactUserChange : handleShipperUserChange}
                                    >
                                        <option value="">Select Contact Person</option>
                                        {(cecOc ? entityUsers : shipperEntityUsers)?.map((u, i) => {
                                            const name = `${u.firstName || ''} ${u.lastName || ''}`.trim();
                                            const email = u.email || u.emailId || u.emailid || '';
                                            return (
                                                <option key={u._id || u.id || i} value={u._id || u.id || u.email}>
                                                    {email ? `${name || email} (${email})` : name}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>
                            </$c>
                        </div>
                    )}
                    <div className="columns" style={{ paddingTop: "10px" }}>
                        <$cr n='2'>First Name *{space}</$cr>
                        <$c n='3'>
                            <input
                                className={`input is-small ${(!buttonClickedAtleastOnce || (cecOc ? brec.firstName : shipperDetails.firstName)) ? '' : 'is-danger'}`}
                                value={cecOc ? (brec.firstName || '') : (shipperDetails.firstName || '')}
                                disabled={cecOc ? true : (shipperEntityUsers.length > 0 ? true : !newShipper)}
                                readOnly={cecOc || shipperEntityUsers.length > 0}
                                onChange={cecOc ? ((e) => brec.firstName = e.target.value) : ((e) => setShipperDetails({ ...shipperDetails, firstName: e.target.value }))}
                            />
                        </$c>
                        <$cr n='2'>Last Name </$cr>
                        <$c n='3'>
                            <input
                                className={`input is-small`}
                                value={cecOc ? (brec.lastName || '') : (shipperDetails.lastName || '')}
                                disabled={cecOc ? true : (shipperEntityUsers.length > 0 ? true : !newShipper)}
                                readOnly={cecOc || shipperEntityUsers.length > 0}
                                onChange={cecOc ? ((e) => brec.lastName = e.target.value) : ((e) => setShipperDetails({ ...shipperDetails, lastName: e.target.value }))}
                            />
                        </$c>
                    </div>
                    <div className="columns">
                        <$cr n='2'>Email ID *</$cr>
                        <$c n='3'>
                            <input
                                className={`input is-small ${(!buttonClickedAtleastOnce || (cecOc ? validEmail(brec.emailid) : shipperDetails.emailId)) ? '' : 'is-danger'}`}
                                disabled={cecOc ? true : (shipperEntityUsers.length > 0 ? true : !newShipper)}
                                readOnly={cecOc || shipperEntityUsers.length > 0}
                                value={cecOc ? (brec.emailid || '') : (shipperDetails.emailId || '')}
                                onChange={cecOc ? ((e) => brec.emailid = e.target.value) : handleEmailChange}
                            />
                        </$c>
                        <$cr n='2'>Contact Number *</$cr>
                        <$c n='3'>
                            <input
                                className={`input is-small ${(!buttonClickedAtleastOnce || (cecOc ? (brec.country !== "India" ? (brec.phone && brec.phone.length > 6) : (brec.phone && brec.phone.length === 10)) : (shipperDetails.mobileNumber && shipperDetails.mobileNumber.length > 6))) ? '' : 'is-danger'}`}
                                value={cecOc ? (brec.phone || '') : (shipperDetails.mobileNumber || '')}
                                onChange={cecOc ? ((e) => brec.phone = e.target.value) : ((e) => setShipperDetails({ ...shipperDetails, mobileNumber: e.target.value }))}
                                min="10"
                                onKeyDown={(e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                                disabled={cecOc ? true : (shipperEntityUsers.length > 0 ? true : !newShipper)}
                                readOnly={cecOc || shipperEntityUsers.length > 0}
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/\D/g, '').slice(0, 15);
                                }}
                            />
                        </$c>
                    </div>

                    {!cecOc ?
                    <div>
                    <div className="columns">
                     <$cr n='2'>Send Milestone alerts ?</$cr>
                        <$c n='3'>
                            <input className={`checkbox`} type = 'checkbox' checked={milestoneAlert}
                               onChange={() => setMilestoneAlert(!milestoneAlert)} 
                            />
                        </$c>
                    </div>
                     <div className="columns">

                        <$cr n='2'>State *</$cr>
                        <$c n='3'><StateSelect label={true} disabled={!cecOc && !newShipper} countryValue={shipperDetails.country} value={shipperDetails.state} callback={(e) => {
                            setShipperDetails(prevShipperDetails => ({
                                ...prevShipperDetails,
                                state: e?.name,
                                city: ""
                            }));

                        }}></StateSelect></$c>
                         {shipperDetails.country !== "India" ? (
                            <>
                                <$cr n='2'>City</$cr>
                                <$c n='3'>
                                    <input
                                    className="input is-small"
                                        value={shipperDetails.city}
                                        disabled={!cecOc && !newShipper}
                                        onChange={((e) => setShipperDetails({ ...shipperDetails, city: e.target.value }))}
                                    />
                                </$c>
                            </>
                        ) : (
                            <>
                            <$cr n='2'>City *</$cr>  
                            <$c n='3'><CitySelect label={true} disabled={!cecOc && !newShipper} stateValue={shipperDetails.state} value={shipperDetails.city} callback={(e) => {
                                setShipperDetails(prevShipperDetails => ({
                                    ...prevShipperDetails,
                                    city: e?.name
                                }))

                            }}/></$c>
                            </>
                        )}
                    </div> </div> : null
                    }
                    <div className="columns is-narrow">
                        <$cr n='2'>PIN/ZIP Code *</$cr>
                        <$c n='3'>
                            {
                                hasToAutoPopulateEntityDetail && cecOc ? brec.pin
                                    : <input className={`input is-small ${(!buttonClickedAtleastOnce || (cecOc ? true : shipperDetails.pincode)) ? '' : 'is-danger'}`} disabled={!cecOc && !newShipper} type="number" value={cecOc ? brec.pin : shipperDetails.pincode} onKeyDown={(e) => {
                                        if (e.key === 'e') {
                                            e.preventDefault();
                                        }
                                    }}
                                        onChange={cecOc ? ((e) => brec.pin = e.target.value) : handlePincodeChange}
                                    />
                            }
                        </$c>
                        <$cr n='2'>Country</$cr>
                        <$c n='3'>
                            {
                                hasToAutoPopulateEntityDetail && cecOc
                                    ? brec.country
                                    : shipperDetails.country
                            }
                        </$c>
                    </div>
                </div>
                {!(!cecOc && !cecOd) ?
                    <div>
                        { cecOc && !cecOd?
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <$cr n='2'>
                         <h2 style={{ paddingTop: "10px", fontSize: "1rem", fontWeight: "bold" }}>Do you want to add consignee details?</h2></$cr>
                         <$c n='3'><Agyesno label={''} record={''} name={''} callback={(val)=>{
                            setConsigneeForm(!consigneeForm)
                            const shipperSet = shipperDefault
                            shipperSet.country = shipperDetails.country
                            setShipperDetails(shipperSet)
                            setShipperSearch("")
                         }}/></$c>
                </div>:null
}
                        {consigneeForm && <div>
                        <h2 style={{ paddingTop: "10px", fontSize: "1rem", fontWeight: "bold" }}>Consignee / Importer details {cecOd && ' - Invoicing'}</h2>
                        <div className="columns" style={{ paddingTop: "10px" }}>
                            <$cr n='2'>Consignee Name</$cr>
                            <$c n='3'>
                                <div className="select is-small">
                                    <input
                                        type="text"
                                        className="input is-small"
                                        placeholder="Search Consignee"
                                        value={cecOd ? brec.company : shipperSearch}
                                        onChange={handleSearchChange}
                                        disabled={cecOd}
                                        onClick={() => setShowSearchList(true)}
                                    />
                                    <ul>
                                        {showSearchList && !cecOd && (
                                            <div className="select-menu" style={{ position: 'absolute', top: '100%', left: 0, zIndex: 999, backgroundColor: 'white', border: '1px solid #ccc', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', padding: '0.5rem' }} ref={searchListRef}>
                                                <ul>
                                                    {filteredShipperList?.map((shipper, index) => (
                                                        <li key={index} onClick={() => {
                                                            setNewShipper(false)
                                                            if (cecOd) {
                                                                brec.company = shipper.companyName;
                                                            } else {
                                                                setShipperDetails(shipper);
                                                                setShipperSearch(shipper.companyName);
                                                            }
                                                            setShowSearchList(false); // Close search list on click
                                                        }}>
                                                            {shipper.companyName}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}
                                    </ul>

                                </div>
                            </$c>
                        </div>


                        {cecOd ?
                            (<div className="columns">
                                <$cr n='2'>Branch *{space}</$cr>
                                <$c n='3'>
                                    <div className={`select wd_100 ${validbranch ? '' : 'is-danger'}`}>
                                        <select className={`select is-fullwidth is-small ${validbranch ? '' : 'is-danger'}`} value={brec.branchId} onChange={(e) => setBranchfn(e)}
                                        //   disabled={checkSingleBranch()} 
                                        >
                                            <option value=""  >Select Branch</option>
                                            {
                                                branches?.map((r, i) => {
                                                    return (<option value={r.branchId}>{`${r.state?.split("/")[0]} - ${(r.gst.length > 0 ? r.gst : r.tinNum)}`}</option>)
                                                })
                                            }
                                            {/* <option>hyh</option> */}
                                        </select>
                                    </div>
                                </$c>
                            </div>) : null}
                        <div className="columns">
                            <$cr n='2'>Address {cecOd && '*'}</$cr>
                            <$c n='3'>
                                {
                                    (hasToAutoPopulateEntityDetail && cecOd) ?
                                        <div className={` select wd_100 ${!buttonClickedAtleastOnce || validAddress ? '' : 'is-danger'}`}>
                                            <select className={`wd_100 p-1 select is-fullwidth is-small ${cecOd ? validAddress : true ? '' : 'is-danger'}`} value={addressObj}
                                                onChange={cecOd ? (r, i) => setAddressFn(r, i) : ((e) => setShipperDetails({ ...shipperDetails, address: e.target.value }))} disabled={!cecOd && !newShipper}
                                            // brec.pin   = e.target.value 
                                            // console.log(i)
                                            >{<option value=''>select address</option>}{checkSelectedBranch()?.branchAddresses?.map((r, i) => <option key={i} value={JSON.stringify(r)} >{r.address}</option>)}</select></div> : <textarea className={`textarea wd_100 ${!buttonClickedAtleastOnce || cecOd ? validAddress : true ? '' : 'is-danger'}`} defaultValue={cecOd ? brec.address : shipperDetails.address}
                                                disabled={!cecOd && !newShipper} onChange={cecOd ? ((e) => { brec.address = e.target.value; setvalidAddress(true); }) : ((e) => setShipperDetails({ ...shipperDetails, address: e.target.value }))}
                                        />
                                }
                            </$c>
                        </div>
                        {(cecOd || (!cecOd && shipperEntityUsers.length > 0)) && (
                            <div className="columns" style={{ paddingTop: "10px" }}>
                                <$cr n='2'>Contact Person *</$cr>
                                <$c n='3'>
                                    <div className={`select wd_100 is-small ${(!buttonClickedAtleastOnce || (cecOd ? selectedUserId || (brec.firstName && brec.emailid) : selectedShipperUserId || (shipperDetails.firstName && shipperDetails.emailId))) ? '' : 'is-danger'}`}>
                                        <select
                                            className="select is-fullwidth is-small wd_100"
                                            value={cecOd ? selectedUserId : selectedShipperUserId}
                                            onChange={cecOd ? handleContactUserChange : handleShipperUserChange}
                                        >
                                            <option value="">Select Contact Person</option>
                                            {(cecOd ? entityUsers : shipperEntityUsers)?.map((u, i) => {
                                                const name = `${u.firstName || ''} ${u.lastName || ''}`.trim();
                                                const email = u.email || u.emailId || u.emailid || '';
                                                return (
                                                    <option key={u._id || u.id || i} value={u._id || u.id || u.email}>
                                                        {email ? `${name || email} (${email})` : name}
                                                    </option>
                                                );
                                            })}
                                        </select>
                                    </div>
                                </$c>
                            </div>
                        )}
                        <div className="columns" style={{ paddingTop: "10px" }}>
                            <$cr n='2'>First Name {cecOd && '*'}{space}</$cr>
                            <$c n='3'>
                                <input
                                    className={`input is-small ${(!buttonClickedAtleastOnce || (cecOd ? brec.firstName : true)) ? '' : 'is-danger'}`}
                                    value={cecOd ? (brec.firstName || '') : (shipperDetails.firstName || '')}
                                    disabled={cecOd ? true : (shipperEntityUsers.length > 0 ? true : !newShipper)}
                                    readOnly={cecOd || shipperEntityUsers.length > 0}
                                    onChange={((e) => cecOd ? (brec.firstName = e.target.value) : setShipperDetails({ ...shipperDetails, firstName: e.target.value }))}
                                />
                            </$c>
                            <$cr n='2'>Last Name{cecOd && '*'}</$cr>
                            <$c n='3'>
                                <input
                                    className={`input is-small`}
                                    value={cecOd ? (brec.lastName || '') : (shipperDetails.lastName || '')}
                                    disabled={cecOd ? true : (shipperEntityUsers.length > 0 ? true : !newShipper)}
                                    readOnly={cecOd || shipperEntityUsers.length > 0}
                                    onChange={((e) => cecOd ? (brec.lastName = e.target.value) : setShipperDetails({ ...shipperDetails, lastName: e.target.value }))}
                                />
                            </$c>
                        </div>
                        <div className="columns">
                            <$cr n='2'>Email ID {cecOd && '*'}</$cr>
                            <$c n='3'>
                                <input
                                    className={`input is-small ${(!buttonClickedAtleastOnce || (cecOd ? validEmail(brec.emailid) : true)) ? '' : 'is-danger'}`}
                                    disabled={cecOd ? true : (shipperEntityUsers.length > 0 ? true : !newShipper)}
                                    readOnly={cecOd || shipperEntityUsers.length > 0}
                                    value={cecOd ? (brec.emailid || '') : (shipperDetails.emailId || '')}
                                    onChange={cecOd ? ((e) => brec.emailid = e.target.value) : handleEmailChange}
                                />
                            </$c>
                            <$cr n='2'>Contact Number {cecOd && '*'}</$cr>
                            <$c n='3'>
                                <input
                                    className={`input is-small ${(!buttonClickedAtleastOnce || (cecOd ? (brec.country !== "India" ? (brec.phone && brec.phone.length > 6) : (brec.phone && brec.phone.length === 10)) : true)) ? '' : 'is-danger'}`}
                                    value={cecOd ? (brec.phone || '') : (shipperDetails.mobileNumber || '')}
                                    disabled={cecOd ? true : (shipperEntityUsers.length > 0 ? true : !newShipper)}
                                    readOnly={cecOd || shipperEntityUsers.length > 0}
                                    onChange={cecOd ? ((e) => brec.phone = e.target.value) : ((e) => setShipperDetails({ ...shipperDetails, mobileNumber: e.target.value }))}
                                    min="10"
                                    onKeyDown={(e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                                    onInput={(e) => {
                                        e.target.value = e.target.value.replace(/\D/g, '').slice(0, 15);
                                    }}
                                />
                            </$c>
                        </div>
                        {!cecOd ? <div>
                            <div className="columns">
                    <$cr n='2'>Send Milestone alerts ?</$cr>
                        <$c n='3'>
                            <input className={`checkbox`} type = 'checkbox' checked={milestoneAlert}
                                onChange={() => setMilestoneAlert(!milestoneAlert)} 
                            />
                        </$c>
                    </div><div className="columns">
                            <$cr n='2'>State *</$cr>
                            <$c n='3'><StateSelect label={true} disabled={!cecOd && !newShipper} countryValue={shipperDetails.country} value={shipperDetails.state} callback={(e) => {
                                setShipperDetails(prevShipperDetails => ({
                                    ...prevShipperDetails,
                                    state: e?.name,
                                    city: ""
                                }));

                            }}></StateSelect></$c>
                            {shipperDetails.country !== "India" ? (
                                <>
                                    <$cr n='2'>City</$cr>
                                    <$c n='3'>
                                        <input
                                        className="input is-small"
                                            value={shipperDetails.city}
                                            disabled={!cecOd && !newShipper}
                                            onChange={((e) => setShipperDetails({ ...shipperDetails, city: e.target.value }))}
                                        />
                                    </$c>
                                </>
                            ) : (
                                <>
                                <$cr n='2'>City *</$cr>  
                                <$c n='3'><CitySelect label={true} disabled={!cecOd && !newShipper} stateValue={shipperDetails.state} value={shipperDetails.city} callback={(e) => {
                                    setShipperDetails(prevShipperDetails => ({
                                        ...prevShipperDetails,
                                        city: e?.name
                                    }));

                                }}/></$c>
                                </>
                            )}
                        </div></div> : null
                        }
                        <div className="columns is-narrow">
                            <$cr n='2'>PIN/ZIP Code</$cr>
                            <$c n='3'>
                                {
                                    hasToAutoPopulateEntityDetail && cecOd ? brec.pin
                                        : <input className={`input is-small`} disabled={!cecOd && !newShipper} type="number" value={cecOd ? brec.pin : shipperDetails.pincode} onKeyDown={(e) => {
                                            if (e.key === 'e') {
                                                e.preventDefault();
                                            }
                                        }}
                                            onChange={cecOd ? ((e) => brec.pin = e.target.value) : handlePincodeChange}
                                        />
                                }
                            </$c>
                            <$cr n='2'>Country</$cr>
                            <$c n='3'>
                                {
                                    hasToAutoPopulateEntityDetail && cecOd
                                        ? brec.country
                                        : brec.destinationCount
                                }
                            </$c>
                        </div>
                        </div>}
                    </div> : null
                }</div>:
                <div>
                    <div>
  <h2 style={{ paddingTop: "10px", fontSize: "1rem", fontWeight: "bold" }}>Shipper / Exporter details</h2>
  <div className="columns">
    <$cr n='2'>Shipper Name</$cr>
    <$c n='3'>
      <input
        type="text"
       className={`input is-small ${(buttonClickedAtleastOnce && !brec.shipperCompany) ? 'is-danger' : ''}`}
        placeholder="Enter Shipper Name"
        onChange={handleFlexiBookingChange(brec, 'shipperCompany')}
      />
    </$c>                                      
    <$cr n='2'>Address</$cr>
    <$c n='3'>
      <textarea
        className="textarea is-small"
        onChange={handleFlexiBookingChange(brec, 'shipperAddress')}
      />
    </$c>
  </div>
<hr />

  <h2 style={{ paddingTop: "10px", fontSize: "1rem", fontWeight: "bold" }}>Consignee / Importer details</h2>

  <div className="columns">
    <$cr n='2'>Consignee Name</$cr>
    <$c n='3'>
      <input
        type="text"
         className={`input is-small ${(buttonClickedAtleastOnce && !shipperDetails.companyName) ? 'is-danger' : ''}`}
        placeholder="Enter Consignee Name"
        value={shipperDetails.companyName}
        onChange={(e) => {
            setShipperDetails({ ...shipperDetails, companyName: e.target.value })
                setShipperSearch(e.target.value)
            }}
      />
    </$c>
    <$cr n='2'>Address</$cr>
    <$c n='3'>
      <textarea
        className="textarea is-small"
        onChange={(e) => setShipperDetails({ ...shipperDetails, address: e.target.value })}
      />
    </$c>
  </div>

</div>

                    </div>}


                {(!flexiBooking || (!cecOc && !cecOd)) && (
  <div>
    <h2 style={{ paddingTop: "10px", fontSize: "1rem", fontWeight: "bold" }}>
      {flexiBooking ? 'Invoice' : 'Booking'} Details
    </h2>

    <div className="columns">
      {!flexiBooking && (
        <>
         
                                                <$cr n="2">Entity Name{space}</$cr>
                                                <$c n="3">
                                                    <div className="input wd_100">
                                                        <input
                                                            type="text"
                                                            className="input is-fullwidth is-small"
                                                            value={brec.company}
                                                            onChange={handleSearchChange}
                                                            disabled
                                                        />
                                                    </div>
                                                </$c>
       
                                                    
          
         
        </>
      )}
    </div>

    <div className="columns">
      <$cr n="2">Branch *{space}</$cr>
      <$c n="3">
        <div className={`select wd_100 ${validbranch ? '' : 'is-danger'}`}>
          <select
            className={`select is-fullwidth is-small ${validbranch ? '' : 'is-danger'}`}
            value={brec.branchId}
            onChange={setBranchfn}
            // disabled={checkSingleBranch()} 
          >
            <option value="">Select Branch</option>
            {branches?.map((r, i) => (
              <option key={i} value={r.branchId}>
                {`${r.state?.split("/")[0]} - ${r.gst.length > 0 ? r.gst : r.tinNum}`}
              </option>
            ))}
          </select>
        </div>
      </$c>
      <$cr n="2">Address *</$cr>
      <$c n="3">
        {hasToAutoPopulateEntityDetail ? (
          <div className={`select wd_100 ${validAddress ? '' : 'is-danger'}`}>
            <select
              className={`wd_100 p-1 select is-fullwidth is-small ${validAddress ? '' : 'is-danger'}`}
              value={addressObj}
              onChange={(r, i) => setAddressFn(r, i)}
            //   disabled={checkSingleBranchAddress()} 
            >
              <option value="">select address</option>
              {checkSelectedBranch()?.branchAddresses?.map((r, i) => (
                <option key={i} value={JSON.stringify(r)}>
                  {r.address}
                </option>
              ))}
            </select>
          </div>
        ) : (
          <textarea
            className={`textarea wd_100 ${validAddress ? '' : 'is-danger'}`}
            defaultValue={brec.address}
            onChange={
              cecOd
                ? (e) => {
                    brec.address = e.target.value;
                    setvalidAddress(true);
                  }
                : (e) => setShipperDetails({ ...shipperDetails, address: e.target.value })
            }
          />
        )}
      </$c>
    </div>

    <div className="columns">
      <$cr n="2">PIN/ZIP Code</$cr>
      <$c n="3">
        {hasToAutoPopulateEntityDetail ? (
          brec.pin
        ) : (
          <input
            type="number"
            className="input is-small"
            value={brec.pin}
            onKeyDown={(e) => {
              if (e.key === 'e') e.preventDefault();
            }}
            onChange={(e) => (brec.pin = e.target.value)}
          />
        )}
      </$c>
    </div>

    <div className="columns">
      <$cr n="2">Country</$cr>
      <$c n="3">
        {hasToAutoPopulateEntityDetail ? (
          brec.country
        ) : (
          <div className="control">
            <div className={`select is-fullwidth is-small ${!buttonClickedAtleastOnce || brec.country ? '' : 'is-danger'}`}>
              <select
                className={`select is-fullwidth is-small ${!buttonClickedAtleastOnce || brec.country ? '' : 'is-danger'}`}
                value={brec.country}
                onChange={(e) => (brec.country = e.target.value)}
              >
                {ServerLists.countryNameList.map((e, i) => (
                  <option key={i} value={e}>
                    {e}
                  </option>
                ))}
              </select>
            </div>
          </div>
        )}
      </$c>
    </div>
  </div>
)}
            <div>
            <h2 style={{ paddingTop: "10px", fontSize: "1rem", fontWeight: "bold" }}>Shipment details</h2>
            <div className="columns">
                <$cr n="2">
                    Freight?
                </$cr>
                <$c n="3">
                    <div className="field">
                <div className="control">
                    <div className="select is-small is-fullwidth">
                    <select value={paymentType} onChange={(e) => setPaymentType(e.target.value)}>
                        <option value="Prepaid">Prepaid</option>
                        <option value="Collect">Collect</option>
                    </select>
                    </div>
                </div>
                </div>
                </$c>
                {FCL_EXPORT_BOOKING && 
                <>
                    <$cr n="2">
                        ETD @ POL {brec?.contract?.tradeType === "Export" && "*"}
                    </$cr>
                    <$c n='3'>
                        <input class="input is-small" className={`input is-small ${validEtdAtPol ? '' : 'is-danger'}`} value={Utils.ddmmyyyystring(brec?.etd_at_pol)} type="date"
                            onChange={(e)=>{
                                brec.etd_at_pol = Utils.ddmmyyyystring(e.target.value);
                                setEtdAtPol(true)
                            }} />
                    </$c>
                </>
                }
            </div>
            <div className="columns">
                <$cr n='2'>Incoterms *</$cr>
                <$c n='3'>
                    {
                        (incoEditable) ? (
                            <div className="control">
                                <div className={`select ${validIncoterms ? '' : 'is-danger'}`}>
                                    <select
                                        className={`select is-fullwidth is-small ${validIncoterms ? '' : 'is-danger'}`}
                                        value={brec.incoTerms}
                                        onChange={(e) => {
                                            brec.incoTerms = e.target.value;
                                            setValidIncoterms(true)
                                        }}
                                    >
                                        {incoTermsList.map((e) => (
                                            <option key={e} value={e}>
                                                {e}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        ) : (
                            <div className="select is-fullwidth">
                                <select>
                                    <option>{brec.incoTerms}</option>
                                </select>
                            </div>
                        )
                    }

                </$c>
                <$cr n='2'>Commodity Type *</$cr>
                <$c n='3'>
                    {
                        (ctypeEditable) ? (
                            <div className="control">
                                <div className={`select ${validCommodityType ? '' : 'is-danger'}`}>
                                    <select
                                        className={`select is-fullwidth is-small ${validCommodityType ? '' : 'is-danger'}`}
                                        value={brec.commodityType}
                                        onChange={(e) => {
                                            brec.commodityType = e.target.value;
                                            setValidCommodityType(true)
                                        }}
                                    >
                                        {commodityList.map((e) => (
                                            <option key={e} value={e}>
                                                {e}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        ) : (
                            <div className="select is-fullwidth">
                                <select>
                                    <option>{brec.commodityType}</option>
                                </select>
                            </div>
                        )
                    }

                </$c>
            </div>
            <div className="columns">
                {stype() === "FCL" && (<>
                <$cr n= '2'>HSN Code {brec?.contract?.tradeType === "Export" && "*"}</$cr>
                <$c n='3'>
                    <div className={`is-fullwidth ${validHSN ? '' : 'is-danger'}`} 
                        style={{height: "auto", position: "relative"}} ref={dropdownRef}>
                        <input
                            type="text"
                            value={searchTerm}
                            onChange={handleHSNSearch}
                            placeholder="Search HSN Code..."
                            className="search-input" 
                            style={{
                            width: "100%",
                            padding: "5px 8px",
                            borderRadius: "4px",
                            outline: "none",
                            border: validHSN ? "1px solid #ccc" : "1px solid red",
                            position: "relative"
                            }}
                        />
                        {isDropdownVisible && (
                            <div
                                // className="dropdown"
                                style={{
                                    position: "absolute",
                                    top: "30px",
                                    width: "100%",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                    background: "#fff",
                                    zIndex: 100,
                                }}
                                >
                                {filteredOptions.length > 0 ? (
                                    filteredOptions.map((item) => (
                                    <div
                                        key={item.id}
                                        onClick={() => handleSelect(item)}
                                        style={{
                                        padding: "10px",
                                        cursor: "pointer",
                                        borderBottom: "1px solid #f0f0f0",
                                        }}
                                        onMouseOver={(e) => (e.currentTarget.style.background = "#f9f9f9")}
                                        onMouseOut={(e) => (e.currentTarget.style.background = "#fff")}
                                    >
                                        {item.commodityDescription} ({item.commodityTypeName})
                                    </div>
                                    ))
                                ):(
                                    <div style={{ padding: "10px", color: "#888" }}>No results found</div>
                                )}
                            </div>
                        )}
                        <div
                            className="selected-tags"
                            style={{
                                display: "flex",
                                flexWrap: "wrap", // Allow tags to wrap to the next line
                                gap: "5px",
                                marginTop: "10px",
                                width: "100%", // Full width of the container
                                maxWidth: "100%", // Prevent overflowing the screen width
                                overflow: "hidden", // Prevent horizontal scrolling
                                boxSizing: "border-box", // Include padding in width calculation
                            }}
                            >
                            {selectedItems.map((item) => (
                                <div
                                key={item.id}
                                className="tag"
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    background: "#e0e0e0",
                                    borderRadius: "20px",
                                    fontSize: "14px",
                                    padding: "8px 12px", 
                                    maxWidth: "200px", 
                                    whiteSpace: "nowrap", 
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    boxSizing: "border-box",
                                    justifyContent: "flex-start",
                                }}
                                title={`${item.commodityTypeName}`} // Tooltip for full text
                                >
                                    <span
                                    onClick={() => handleRemoveTag(item.id)}
                                    style={{
                                    marginRight: "5px",
                                    cursor: "pointer",
                                    fontWeight: "bold",
                                    color: "#888",
                                    flexShrink: 0, 
                                    whiteSpace: "nowrap",
                                    }}
                                >
                                    ×
                                </span>
                                <span style={{ flex: "1" }}>
                                    {`${item.commodityTypeName}`}
                                </span>
                                </div>
                            ))}
                        </div>
                    </div>
                    </$c>
                    </>)}
                    {(stype() === 'LCL' || FCL_EXPORT_BOOKING) &&(
                        <>
                            <$cr n='2'>BL Type {(stype() === 'LCL' || FCL_EXPORT_BOOKING) && "*"}</$cr>
                                <$c n='3'>
                                <div className={`select wd_100 ${validBLTypes ? '' : 'is-danger'}`}>
                                    <select
                                        className={`wd_100 p-1 select is-fullwidth is-small ${validBLTypes ? '' : 'is-danger'}`}
                                        value={blType}
                                        onChange={(e) => {
                                            setBlType(e.target.value)
                                            setValidBLTypes(true)
                                        }}
                                    >
                                        <option value="">Select blType</option>
                                        {BL_TYPE.map((r, i) => (
                                            <option key={i} value={r}>
                                            {r}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </$c> 
                        </>)
}
                    {/* <$c> */}
                    {/* <div> */}
                        {/* <div
                            className="selected-tags"
                            style={{
                                display: "flex",
                                flexWrap: "wrap", // Allow tags to wrap to the next line
                                gap: "5px",
                                width: "100%", // Full width of the container
                                maxWidth: "100%", // Prevent overflowing the screen width
                                overflow: "hidden", // Prevent horizontal scrolling
                                boxSizing: "border-box", // Include padding in width calculation
                            }}
                            >
                            {selectedItems.map((item) => (
                                <div
                                key={item.id}
                                className="tag"
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    background: "#e0e0e0",
                                    borderRadius: "20px",
                                    fontSize: "14px",
                                    padding: "8px 12px", 
                                    maxWidth: "200px", 
                                    whiteSpace: "nowrap", 
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    boxSizing: "border-box",
                                    justifyContent: "flex-start",
                                }}
                                title={`${item.commodityDescription} (${item.commodityTypeName})`} // Tooltip for full text
                                >
                                    <span
                                    onClick={() => handleRemoveTag(item.id)}
                                    style={{
                                    marginRight: "5px",
                                    cursor: "pointer",
                                    fontWeight: "bold",
                                    color: "#888",
                                    flexShrink: 0, 
                                    whiteSpace: "nowrap",
                                    }}
                                >
                                    ×
                                </span>
                                <span style={{ flex: "1" }}>
                                    {item.commodityDescription} ({item.commodityTypeName})
                                </span>
                                </div>
                            ))}
                        </div> */}

                    {/* </div> */}

                {/* </$c> */}
            </div>
            <div className="columns">
                {
                    FCL_EXPORT_BOOKING_CARRIERMBL ?
                    <>
                        <$cr n= '2'>Carrier MBL *</$cr>
                        
                        <$c n='3'>
                            <div className={`select wd_100 ${validCarrierMBL ? '' : 'is-danger'}`}>
                            <select
                                className={`wd_100 p-1 select is-fullwidth is-small ${validCarrierMBL ? '' : 'is-danger'}`}
                                value={brec['carrierMBL']}
                                onChange={(e) => {
                                    brec.carrierMBL = e.target.value;
                                    if(e.target.value === ''){
                                        setPendingValue(e.target.value);
                                    }else if (e.target.value === "Yes") {
                                        setPendingValue(e.target.value);
                                        setShowConfirm(true);
                                        setValidCarrierMBL(true);
                                    }else{
                                        setValidCarrierMBL(true);
                                    }
                                }}
                            >
                                <option value="">Select carrierMBL</option>
                                {CARRIER_MBL.map((r, i) => (
                                    <option key={i} value={r}>
                                    {r}
                                    </option>
                                ))}
                                
                            </select>
                            {showConfirm && (
                                <MblConfirmationPopup onConfirm={confirmToggle} onCancel={cancelToggle} />
                            )}
                        </div>
                            {/* {
                                (contractsStore.current.shipmentType.toLowerCase().includes('fcl')
                                    && contractsStore.current.shipmentScope.endsWith('ort')) ?
                                    <Agyesno label='Do you require a Direct Carrier MBL?'
                                        record={brec} name='carrierMBL' callback={handleToggle}/> : null
                            }
                            {showConfirm && (
                                <MblConfirmationPopup onConfirm={confirmToggle} onCancel={cancelToggle} />
                            )} */}
                        </$c>
                    </>  
                    : null
                }
                
                {FCL_EXPORT_BOOKING_SHIPPER_PDA && 
                <>
                    <$cr n= '2'>Shipper PDA *</$cr>
                    <$c n='3'>
                        <div className={`select wd_100 ${validPDA ? '' : 'is-danger'}`}>
                            <select
                                className={`wd_100 p-1 select is-fullwidth is-small ${validBLTypes ? '' : 'is-danger'}`}
                                value={shipperPDA}
                                onChange={(e) => {
                                    setShipperPDA(e.target.value.trim());
                                    setPDA(true)
                                }}
                            >
                                <option value="">Select shipperPDA</option>
                                {SHIPPER_PDA.map((r, i) => (
                                    <option key={i} value={r}>
                                    {r}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </$c>
                </>}
                
            </div>     
                 {/* <div className="columns is-narrow">      
                <$cr n='2'>FBA</$cr>       
                <$c n='2'>
                    {
                        (contractsStore.current.fba!=undefined)?<Agyesno disabled={true} label='' record={brec} name='fba' />:
                        <Agyesno label='' record={brec} name='fba' />
                    }
                </$c>
                <$c n='8'>
                </$c>
            </div> */}
             <h2 style={{ paddingTop: "10px", fontSize: "1rem", fontWeight: "bold" }}>Branch details</h2>
                            <div>
                                {cecOd ?
                                    (<div className="columns">
                                        <$cr n='2'>Branch *{space}</$cr>
                                        <$c n='3'>
                                            <div className={`select wd_100 ${validbranch ? '' : 'is-danger'}`}>
                                                <select className={`select is-fullwidth is-small ${validbranch ? '' : 'is-danger'}`} value={brec.branchId} onChange={(e) => setBranchfn(e)}
                                                //   disabled={checkSingleBranch()} 
                                                >
                                                    <option value=""  >Select Branch</option>
                                                    {
                                                        branches?.map((r, i) => {
                                                            return (<option value={r.branchId}>{`${r.state?.split("/")[0]} - ${(r.gst.length > 0 ? r.gst : r.tinNum)}`}</option>)
                                                        })
                                                    }
                                                    {/* <option>hyh</option> */}
                                                </select>
                                            </div>
                                        </$c>
                                    </div>) : null}
                                <div className="columns">
                                    <$cr n='2'>Address {cecOd && '*'}</$cr>
                                    <$c n='3'>
                                        {
                                            (hasToAutoPopulateEntityDetail && cecOd) ?
                                                <div className={` select wd_100 ${!buttonClickedAtleastOnce || validAddress ? '' : 'is-danger'}`}>
                                                    <select className={`wd_100 p-1 select is-fullwidth is-small ${cecOd ? validAddress : true ? '' : 'is-danger'}`} value={addressObj}
                                                        onChange={cecOd ? (r, i) => setAddressFn(r, i) : ((e) => setShipperDetails({ ...shipperDetails, address: e.target.value }))} disabled={!cecOd && !newShipper}
                                                    // brec.pin   = e.target.value 
                                                    // console.log(i)
                                                    >{<option value=''>select address</option>}{checkSelectedBranch()?.branchAddresses?.map((r, i) => <option key={i} value={JSON.stringify(r)} >{r.address}</option>)}</select></div> : <textarea className={`textarea wd_100 ${!buttonClickedAtleastOnce || cecOd ? validAddress : true ? '' : 'is-danger'}`} defaultValue={cecOd ? brec.address : shipperDetails.address}
                                                        disabled={!cecOd && !newShipper} onChange={cecOd ? ((e) => { brec.address = e.target.value; setvalidAddress(true); }) : ((e) => setShipperDetails({ ...shipperDetails, address: e.target.value }))}
                                                />
                                        }
                                    </$c>
                                   </div> 
                                    {
                                        <div className="columns">
                                            <>
                                                <$cr n='2'>Sales Person</$cr>
                                                <$c n='3'>
                                                    <div className={`select wd_100 ${validPDA ? '' : 'is-danger'}`}>
                                                        <select
                                                            className={`wd_100 p-1 select is-fullwidth is-small ${validBLTypes ? '' : 'is-danger'}`}
                                                            value={brec?.salesperson}
                                                            onChange={(e) => {
                                                                // setShipperPDA(e.target.value.trim());
                                                                // setPDA(true)
                                                                brec.salesperson = e.target.value
                                                            }}
                                                            disabled={isRMAvailable}
                                                        >
                                                            <option value="">Select Sales Person</option>
                                                            {agActiveList?.map((r, i) => (
                                                                <option value={r.value}>
                                                                    {r.value}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </$c>
                                                <$cr n='2'>Customer Success</$cr>
                                                <$c n='3'>
                                                    <div className={`select wd_100 ${validPDA ? '' : 'is-danger'}`}>
                                                        <select
                                                            className={`wd_100 p-1 select is-fullwidth is-small ${validBLTypes ? '' : 'is-danger'}`}
                                                            value={brec?.customerService}
                                                            onChange={(e) => {
                                                                // setShipperPDA(e.target.value.trim());
                                                                // setPDA(true)
                                                                brec.customerService = e.target.value
                                                            }}
                                                             disabled={isCSAvailable}
                                                        >
                                                            <option value="">Select Customer Success</option>
                                                            {agActiveList?.map((r, i) => (
                                                                <option value={r.value}>
                                                                    {r.value}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </$c>

                                            </> </div>}
                                    {<div className="columns">
                                        <>
                                            <$cr n='2'>Nomination</$cr>
                                            <$c n='3'>
                                                <span disabled={true

                                                } style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', width: '40px', cursor: 'default' }}>
                                                    {
                                                        (brec.contract.nomination) ?
                                                            <img height='36px' width='36px' src={on} alt="on" style={{ margin: 0 }}></img> :
                                                            <img height='36px' width='36px' src={off} alt="off" style={{ margin: 0 }}></img>
                                                    }
                                                </span>
                                            </$c>
                                              <>
                                            <$cr n='2'>{process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE} Branch</$cr>
                                            <$c n='3'>
                                             <div className={`select wd_100 ${validPDA ? '' : 'is-danger'}`}>
                                                   <select
                    className="select is-small "
                    style={{ width: "100%", border: "1px solid #d1d1e0" }}
                    onChange={(e) => brec.agragaBranch = e.target.value}
                    value={brec?.agragaBranch || ""}
                    id="CB_agragaBranch">
                    <option selected disabled value=""
                    >
                      Select {process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE} Branch
                    </option>                 
                    {sortedbranches.map((r, i) => {
                          return <option
                            selected={shouldSelectOption(
                              r,
                              brec?.agragaBranch
                            )}>
                            {r}
                          </option>

                        })}               
                  </select>
                                                    </div>
                                               
                                            </$c></>
                                            
                                            </></div>}                                                                              

                            </div>
            <h2 style={{ paddingTop: "10px", fontSize: "1rem", fontWeight: "bold" }}>Cargo Value</h2>
                                        <div className="columns">
                               
                                    <$cr n='2'>Currency</$cr>
                                                <$c n='3'>
                                                    
                                                            <div className="control">
                                                                <div className={`select`}>
                                                                    <select
                                                                        className={`select is-fullwidth is-small`}
                                                                        value={brec.cargovalcur}
                                                                        onChange={(e) => {
                                                                            brec.cargovalcur = e.target.value
                                                                        }}
                                                                    >
                                                                        {configStore.getCurrencyList().map((e) => (
                                                                            <option key={e} value={e}>
                                                                                {e}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </div>
                            
                                                </$c>
                                            <$cr n='2'>Amount</$cr>
                                                <$c n='3'>
                                                    <input class="input is-small" className={`input is-small`} value={brec.cargoval} type="number"
                                                            onChange={(e)=>{
                                                                brec.cargoval = e.target.value.trim()
                                                            }} />
                            
                                                </$c>
                                                
                                   
                            </div>
            {
                (brec.contract.fba==='Yes')? <>
                <h2 style={{ paddingTop: "10px", fontSize: "1rem", fontWeight: "bold" }}>FC</h2>
                {brec.contract?.warehouse === 'AMAZON' && (<div className="columns is-narrow">    
                        <$cr n='2'>Merchant ID</$cr>
                        <$c n='3'>
                            <input className={`input is-small ${faberror.indexOf("merchantID")!=-1?"is-danger":""}`} defaultValue={brec.merchantID}
                                onChange={(e)=>{
                                    brec.merchantID=Utils.removeSpecialCharacters(e.target.value.trim(),14)
                                }}
                            />
                        </$c>
                    </div>)}
                    {
                        brec.fbaDetails!=undefined && brec.fbaDetails.length>0 && brec.fbaDetails.map((k,i)=>{
                            return <>
                            {
                                brec.fbaDetails.length>1?<div className="columns is-narrow">    
                                <$cr n='2'><h2 style={{ paddingTop: "10px", fontSize: "0.7rem", fontWeight: "bold" }}>Destination {i+1}</h2></$cr>
                            </div>:""
                            }
                            {
                                k.map((e,j)=>{
                            return <><div className="columns is-narrow">   
                        <$cr n='2'>FC ID {(process.env.REACT_APP_FBA_Mandatory != undefined && process.env.REACT_APP_FBA_Mandatory=='yes')?'*':""}</$cr>
                        <$c n='3'>
                                <input class="input is-small" className={`input is-small ${faberror.indexOf("fbaID"+i+j)!=-1?"is-danger":""}`} defaultValue={brec.fbaDetails[i][j].fbaID}
                                    onChange={(e)=>{
                                        let f = faberror
                                    const index = f.indexOf("fbaID"+i+j);
                                    if (index > -1) { 
                                        f.splice(index, 1);
                                    }
                                    setFbaerror(f)
                                        brec.fbaDetails[i][j].fbaID=e.target.value.trim()
                                    }}
                                />
                        </$c>
                        {brec.contract?.warehouse === 'AMAZON' ? (<><$cr n='2'>Amazon Reference ID {(process.env.REACT_APP_FBA_Mandatory != undefined && process.env.REACT_APP_FBA_Mandatory=='yes')?'*':""}</$cr>
                        <$c n='3'>
                            <input className={`input is-small ${faberror.indexOf("purchaseOrderID"+i+j)!=-1?"is-danger":""}`} defaultValue={brec.fbaDetails[i][j].purchaseOrderID}
                                onChange={(e)=>{
                                    let f = faberror
                                    const index = f.indexOf("purchaseOrderID"+i+j);
                                    if (index > -1) { 
                                        f.splice(index, 1);
                                    }
                                    setFbaerror(f)
                                    brec.fbaDetails[i][j].purchaseOrderID=Utils.removeSpecialCharacters(e.target.value.trim(),8)
                                }}
                            />
                        </$c> </>) : <></>}
                        </div><div className="columns is-narrow">
                            <$cr n='2'>PO Issuance Date {(process.env.REACT_APP_FBA_Mandatory != undefined && process.env.REACT_APP_FBA_Mandatory=='yes')?'*':""}</$cr>
                                                                <$c n='3'>
                                                                    <input className={`input is-small ${faberror.indexOf("poExpiryDate"+i+j)!=-1?"is-danger":""}`} type="date" value={brec.fbaDetails[i][j].poExpiryDate==undefined?"":brec.fbaDetails[i][j].poExpiryDate}
                                                                        onChange={(e)=>{
                                                                            let f = faberror
                                                                            const index = f.indexOf("poExpiryDate"+i+j);
                                                                            if (index > -1) { 
                                                                                f.splice(index, 1);
                                                                            }
                                                                            setFbaerror(f)
                                                                            brec.fbaDetails[i][j].poExpiryDate=e.target.value
                                                                        }}
                                                                        // onBlur={()=>{setFbaupdatecheck(fbaupdatecheck+1)}}
                                                                        //onBlur={BookingsApi.setcustrefBooking(bookingsStore.current._id,brec.fbaDetails,brec.merchantID)}
                                                                    />
                                                                </$c>
                        <$c n='5'>
                                    <p className="control" style={{textAlign:"right"}}>
            {
              (k.length!=1)?<button className="button is-danger"
              onClick={(e) => {
                brec.fbaDetails = delfba(i,j,brec.fbaDetails)   
             }}>
             <span className="icon is-small">
                 <i className="fas fa-trash"></i>
             </span>
         </button>:""
            }
          &nbsp;
          {
            (k.length-1==j)?
            <button className="button is-success"
                                                                   onClick={(e) => {
                                                                    brec.fbaDetails[i].push({fbaID : "", purchaseOrderID : ""})
                                                                  }}>
                                                                  <span className="icon is-small">
                                                                      <i className="fas fa-plus"></i>
                                                                  </span>
                                                              </button>:""
          }
          
          </p>
                                    </$c>
                                </div></>
                                })
                            }
                            </>
                        })
                    }
                </>:<></>
            }
            
                <div className="columns is-narrow">
                    <$cr n='2'>Special Instructions</$cr>
                    <$c n='6'>
                        <textarea rows='3' style={{ fontSize: '0.8rem' }} className="textarea" defaultValue={brec.specialInstructions}
                            onChange={(e) => brec.specialInstructions = e.target.value} />
                    </$c>
                    {/* <$c n='2'>
                        {
                            // (enableMBL().disabled )
                            (contractsStore.current.shipmentType.toLowerCase().includes('fcl')
                                && contractsStore.current.shipmentScope.endsWith('ort')) ?
                                <Agyesno label='Do you require a Direct Carrier MBL?'
                                    record={brec} name='carrierMBL' callback={handleToggle}/> : null
                        }
                        {showConfirm && (
                            <MblConfirmationPopup onConfirm={confirmToggle} onCancel={cancelToggle} />
                        )}
                    </$c> */}
                </div>
                </div>

                <div className="columns">
                    <$c n='1'></$c>
                    <$c n='9'>
                        <div className="table-container ">
                            <table className="table is-fullwidth is-bordered is-striped is-narrow is-hoverable ">
                                <thead>
                                    <tr>
                                        <th style={{ width: '16rem' }}>Required Documents</th>
                                        <th>Document Uploaded</th>
                                        <th style={{ width: '12rem' }}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr id="cwf5">
                                        <td>Commercial Invoice {(TenantUtils.isAgraga() && (brec.contract.hazardous === 'Yes' || brec.contract.temperatureControlled === 'Yes'))? '*': `(Non-Mandatory)`}</td>
                                        <td className={validCommercialInvoice ? '' : 'is-danger-border'}>
                                            {brec.commercialInvoice_filename_list.map(renderLink).map((link,i) => <><p>{link}
                                                    <span className="icon has-text-danger" style={{cursor: 'pointer'}} onClick={() => {
                                                        brec.commercialInvoice_filename_list = delFile(brec.commercialInvoice_filename_list,i)
                                                    }}>
                                                        <i className="fas fa-trash"></i>
                                                    </span></p><br /></>)}
                                        </td>
                                        <td>
                                            <AgCustomFile source='carrierwebform' cat={filecat} filetype='commercialInvoice' parent="cwf5" multi={true}
                                                callback={(filename) => brec.commercialInvoice_filename_list.push(filename)} withBtn={brec.commercialInvoice_filename_list.length > 0} />
                                        </td>
                                    </tr>
                                    <tr id="cwf6">
                                        <td>Packing List {(TenantUtils.isAgraga() && (brec.contract.hazardous === 'Yes' || brec.contract.temperatureControlled === 'Yes'))? '*': `(Non-Mandatory)`}</td>
                                        <td className={validPackingList ? '' : 'is-danger-border'}>{brec.packingList_filename_list.map(renderLink).map((link,i) => <><p>{link}
                                                    <span className="icon has-text-danger" style={{cursor: 'pointer'}} onClick={() => {
                                                        brec.packingList_filename_list = delFile(brec.packingList_filename_list,i)
                                                    }}>
                                                        <i className="fas fa-trash"></i>
                                                    </span></p><br /></>)}</td>
                                        <td>
                                            <AgCustomFile source='carrierwebform' cat={filecat} filetype='packingList' parent="cwf6" multi={true}
                                                callback={(filename) => brec.packingList_filename_list.push(filename)} withBtn={brec.packingList_filename_list.length > 0} />
                                        </td>
                                    </tr>
                                    <tr id="cwf7">
                                        <td>Special Instructions (Non-Mandatory)</td>
                                        <td>
                                            {brec.specialInstructions_filename_list.map(renderLink).map((link,i) => <><p>{link}
                                                    <span className="icon has-text-danger" style={{cursor: 'pointer'}} onClick={() => {
                                                        brec.specialInstructions_filename_list = delFile(brec.specialInstructions_filename_list,i)
                                                    }}>
                                                        <i className="fas fa-trash"></i>
                                                    </span></p><br /></>)}
                                        </td>
                                        <td>
                                            <AgCustomFile source='carrierwebform' cat={filecat} filetype='specialInstructions' parent="cwf7" multi={true}
                                                callback={(filename) => brec.specialInstructions_filename_list.push(filename)} withBtn={brec.specialInstructions_filename_list.length > 0} />
                                        </td>
                                    </tr>
                                    {(contractsStore.current.shipmentType.toLowerCase().includes('fcl') || contractsStore.current.shipmentType.toLowerCase().includes('lcl')) &&
                                    <tr id="cwf8">
                                        <td>Customer Booking Confirmation (Non-Mandatory)</td>
                                        <td>
                                            {brec.custbookingconf_filename_list.map(renderLink).map((link,i) => <><p>{link}
                                                    <span className="icon has-text-danger" style={{cursor: 'pointer'}} onClick={() => {
                                                        brec.custbookingconf_filename_list = delFile(brec.custbookingconf_filename_list,i)
                                                    }}>
                                                        <i className="fas fa-trash"></i>
                                                    </span></p><br /></>)}
                                        </td>
                                        <td>
                                            <AgCustomFile source='carrierwebform' cat={filecat} filetype='custbookingconf' parent="cwf7" multi={true}
                                                callback={(filename) => brec.custbookingconf_filename_list.push(filename)} withBtn={brec.custbookingconf_filename_list.length > 0} />
                                        </td>
                                    </tr>
                                    }
                                    {
                                        (
                                            (brec.commodityType && brec.commodityType.startsWith('Non-Hazardous Chemicals'))
                                            || (brec.contract.hazardous === 'Yes')
                                        ) ?
                                            <tr id="cwf1">
                                                <td>MSDS</td>
                                                <td><p>{renderLink(brec.msds_filename)}
                                                    { brec.msds_filename!=undefined && brec.msds_filename.length!=0 && <span className="icon has-text-danger" style={{cursor: 'pointer'}} onClick={() => {
                                                        brec.msds_filename = ""
                                                    }}>
                                                        <i className="fas fa-trash"></i>
                                                    </span>}</p></td>
                                                <td>
                                                    <AgCustomFile source='carrierwebform' cat={filecat} filetype='msds' multi={false}
                                                        callback={(filename) => brec.msds_filename = filename} parent="cwf1" />
                                                </td>
                                            </tr>
                                            : <></>
                                    }
                                    {
                                        (brec.commodityType && brec.commodityType.startsWith('Non-Hazardous Chemicals')) ?
                                            <tr id="cwf2">
                                                <td>Non-DG Declaration <a className="is-link" href="./Non_Hazardous_Declaration.doc" download>(Download Template)</a></td>
                                                <td><p>{renderLink(brec.nondgdecl_filename)}
                                                    { brec.nondgdecl_filename!=undefined && brec.nondgdecl_filename.length!=0 && <span className="icon has-text-danger" style={{cursor: 'pointer'}} onClick={() => {
                                                        brec.nondgdecl_filename = ""
                                                    }}>
                                                        <i className="fas fa-trash"></i>
                                                    </span>}</p></td>
                                                <td>
                                                    <AgCustomFile cat={filecat} filetype='nondgdecl' multi={false}
                                                        callback={(filename) => brec.nondgdecl_filename = filename} parent="cwf2" />
                                                </td>
                                            </tr> : <></>
                                    }
                                    {
                                        (brec.contract.hazardous === 'Yes') ?
                                            <>
                                                <tr id="cwf3">
                                                    <td>DG Declaration <a className="is-link" href="./DG_Declaration_updated.doc" download>(Download Template)</a></td>
                                                    <td><p>{renderLink(brec.dgdecl_filename)}
                                                    { brec.dgdecl_filename!=undefined && brec.dgdecl_filename.length!=0 && <span className="icon has-text-danger" style={{cursor: 'pointer'}} onClick={() => {
                                                        brec.dgdecl_filename = ""
                                                    }}>
                                                        <i className="fas fa-trash"></i>
                                                    </span>}</p></td>
                                                    <td>
                                                        <AgCustomFile cat={filecat} filetype='dgdecl' multi={false}
                                                            callback={(filename) => brec.dgdecl_filename = filename} parent="cwf3" />
                                                    </td>
                                                </tr>
                                                <tr id="cwf4">
                                                    <td >IIP Certificate *</td>
                                                    <td className={validIIPCertificate ? '' : 'is-danger-border'}><p>{renderLink(brec.iipcert_filename)}
                                                    { brec.iipcert_filename!=undefined && brec.iipcert_filename.length!=0 && <span className="icon has-text-danger" style={{cursor: 'pointer'}} onClick={() => {
                                                        brec.iipcert_filename = ""
                                                    }}>
                                                        <i className="fas fa-trash"></i>
                                                    </span>}</p></td>
                                                    <td   >
                                                        <AgCustomFile
                                                            cat={filecat}
                                                            filetype='iipcert'
                                                            multi={false}
                                                            callback={(filename) => brec.iipcert_filename = filename}
                                                            parent="cwf4"
                                                        />
                                                    </td>
                                                </tr>

                                            </> : <></>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </$c>
                </div>
                <div className="columns">
                    <$cr n='1'></$cr>
                    <$c n='9'>
                        <button className="button is-warning" onClick={(e) => {
                            configStore.scheduleOrCarrierform = 'schedule'
                        }}>
                            <span className="icon" style={{ marginRight: '5px' }}>
                                <i class="fa-solid fa-circle-left"></i>
                            </span>
                            Schedules
                        </button>
                        <div class="buttons" style={{ float: 'right' }}>
                            {/* <button className="button is-danger is-right" onClick={(e) => {
                            bookingsStore.current = {};
                            configStore.homescreenCurrentView = 'list'
                        }} > Cancel </button> */}
                            <button className="button"  style={{backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON, color: "#fff"}} onClick={onSubmit}
                             disabled={isButtonClicked}
                            >
                                Confirm and Save Booking
                            </button>
                        </div>
                    </$c>
                </div>
                <LinkEntityPopupv3 
                    show={showList}
                    onSubmit={(confirmed) => {
                        setshowList(false)
                        if (confirmed) {
                            handleEntitySelect(bookingsStore.linkedEntity)
                        }
                    }}
                    entityList={EntityList}
                    entityId ={shipperDetails.linkedEntity}
                />
            </div>:""
        }   
        </>
    )
}
